/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MOTOLYNK MARKET API
 * Admin, vendor and store APIs of the MOTOLYNK multi-vendor marketplace.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddRequest,
  AddressDefaultRequest,
  Cart,
  CartAddRequest,
  CartVehicleRequest,
  CheckoutPreview,
  CheckoutRequest,
  Country,
  CouponCodeRequest,
  CreateRequest,
  CreateReturnRequest,
  CustomerAddress,
  CustomerAddressInputRequest,
  CustomerCancelRequest,
  CustomerOrder,
  Eligibility,
  Eligible,
  FakePaymentRequest,
  FakePaymentResult,
  InstalledModule,
  Invoice,
  Landing,
  MarkedRead,
  MyReview,
  Notification,
  OpenRequest,
  PaginatedCustomerOrderListList,
  PaginatedMyReviewList,
  PaginatedNotificationList,
  PaginatedReturnListList,
  PaginatedTicketListList,
  PatchedCartQuantityRequest,
  PatchedProfileUpdateRequest,
  PatchedSavedVehicleUpdateRequest,
  PaymentConfirmRequest,
  PaymentOptions,
  PaymentResult,
  PickerItem,
  PickerMake,
  PickerModel,
  PickerVariant,
  Placed,
  ProductReviews,
  PublicSettings,
  RenderingModes,
  ReplyRequest,
  ResolvedVehicle,
  ReturnDetail,
  SavedVehicle,
  SavedVehicleCreateRequest,
  State,
  StoreBanner,
  StoreBlogCategory,
  StoreBrand,
  StoreBrandsListParams,
  StoreCategoriesTreeParams,
  StoreCategoryRef,
  StoreCheckoutPreviewParams,
  StoreCmsBannersParams,
  StoreCmsFaqsParams,
  StoreCmsPageSlugsParams,
  StoreCmsPagesListParams,
  StoreCmsPostsParams,
  StoreFaqCategory,
  StoreFeaturesRetrieve200,
  StoreGeoStatesListParams,
  StoreHome,
  StoreListing,
  StoreMe,
  StoreNotificationsListParams,
  StoreOrdersListParams,
  StorePage,
  StorePageSummary,
  StorePost,
  StorePostPage,
  StoreProductCard,
  StoreProductPage,
  StoreProductReviewsParams,
  StoreProductsListParams,
  StoreProductsRetrieveParams,
  StoreProductsSimilarParams,
  StoreProfile,
  StoreReturnsEligibilityParams,
  StoreReturnsListParams,
  StoreReviewsMineParams,
  StoreSearchSuggestParams,
  StoreSuggestions,
  StoreTicketsListParams,
  StoreVehiclesLandingParams,
  StoreVehiclesMakesListParams,
  StoreVehiclesModelsListParams,
  StoreVehiclesResolveRetrieveParams,
  StoreVehiclesVariantsListParams,
  StoreVehiclesYearsListParams,
  TicketCategory,
  TicketDetail,
  TreeNode,
  UnreadCount,
  Wishlist
} from '../../model';

import { apiFetch } from '../../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type storeAccountAddressesListResponse200 = {
  data: CustomerAddress[]
  status: 200
}

export type storeAccountAddressesListResponseSuccess = (storeAccountAddressesListResponse200) & {
  headers: Headers;
};
;

export type storeAccountAddressesListResponse = (storeAccountAddressesListResponseSuccess)

export const getStoreAccountAddressesListUrl = () => {




  return `/api/v1/store/account/addresses`
}

export const storeAccountAddressesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountAddressesListResponse> => {

  return apiFetch<storeAccountAddressesListResponse>(getStoreAccountAddressesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreAccountAddressesListQueryKey = () => {
    return [
    `/api/v1/store/account/addresses`
    ] as const;
    }


export const getStoreAccountAddressesListQueryOptions = <TData = Awaited<ReturnType<typeof storeAccountAddressesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountAddressesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreAccountAddressesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeAccountAddressesList>>> = ({ signal }) => storeAccountAddressesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeAccountAddressesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreAccountAddressesListQueryResult = NonNullable<Awaited<ReturnType<typeof storeAccountAddressesList>>>
export type StoreAccountAddressesListQueryError = unknown


export function useStoreAccountAddressesList<TData = Awaited<ReturnType<typeof storeAccountAddressesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountAddressesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeAccountAddressesList>>,
          TError,
          Awaited<ReturnType<typeof storeAccountAddressesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreAccountAddressesList<TData = Awaited<ReturnType<typeof storeAccountAddressesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountAddressesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeAccountAddressesList>>,
          TError,
          Awaited<ReturnType<typeof storeAccountAddressesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreAccountAddressesList<TData = Awaited<ReturnType<typeof storeAccountAddressesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountAddressesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreAccountAddressesList<TData = Awaited<ReturnType<typeof storeAccountAddressesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountAddressesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreAccountAddressesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeAccountAddressesCreateResponse201 = {
  data: CustomerAddress[]
  status: 201
}

export type storeAccountAddressesCreateResponseSuccess = (storeAccountAddressesCreateResponse201) & {
  headers: Headers;
};
;

export type storeAccountAddressesCreateResponse = (storeAccountAddressesCreateResponseSuccess)

export const getStoreAccountAddressesCreateUrl = () => {




  return `/api/v1/store/account/addresses`
}

export const storeAccountAddressesCreate = async (customerAddressInputRequest: CustomerAddressInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountAddressesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeAccountAddressesCreateResponse>(getStoreAccountAddressesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(customerAddressInputRequest)
  }
);}





export const getStoreAccountAddressesCreateMutationKey = () => ['storeAccountAddressesCreate'] as const;

export const getStoreAccountAddressesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesCreate>>, TError,StoreAccountAddressesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesCreate>>, TError,StoreAccountAddressesCreateMutationVariables, TContext> => {

const mutationKey = getStoreAccountAddressesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeAccountAddressesCreate>>, StoreAccountAddressesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeAccountAddressesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreAccountAddressesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof storeAccountAddressesCreate>>>
    export type StoreAccountAddressesCreateMutationBody = CustomerAddressInputRequest
    export type StoreAccountAddressesCreateMutationError = unknown
    export type StoreAccountAddressesCreateMutationVariables = {data: CustomerAddressInputRequest}

    export const useStoreAccountAddressesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesCreate>>, TError,StoreAccountAddressesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeAccountAddressesCreate>>,
        TError,
        StoreAccountAddressesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreAccountAddressesCreateMutationOptions(options), queryClient);
    }
    export type storeAccountAddressesUpdateResponse200 = {
  data: CustomerAddress[]
  status: 200
}

export type storeAccountAddressesUpdateResponseSuccess = (storeAccountAddressesUpdateResponse200) & {
  headers: Headers;
};
;

export type storeAccountAddressesUpdateResponse = (storeAccountAddressesUpdateResponseSuccess)

export const getStoreAccountAddressesUpdateUrl = (uid: string,) => {




  return `/api/v1/store/account/addresses/${uid}`
}

export const storeAccountAddressesUpdate = async (uid: string,
    customerAddressInputRequest: CustomerAddressInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountAddressesUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeAccountAddressesUpdateResponse>(getStoreAccountAddressesUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(customerAddressInputRequest)
  }
);}





export const getStoreAccountAddressesUpdateMutationKey = () => ['storeAccountAddressesUpdate'] as const;

export const getStoreAccountAddressesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesUpdate>>, TError,StoreAccountAddressesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesUpdate>>, TError,StoreAccountAddressesUpdateMutationVariables, TContext> => {

const mutationKey = getStoreAccountAddressesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeAccountAddressesUpdate>>, StoreAccountAddressesUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  storeAccountAddressesUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreAccountAddressesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof storeAccountAddressesUpdate>>>
    export type StoreAccountAddressesUpdateMutationBody = CustomerAddressInputRequest
    export type StoreAccountAddressesUpdateMutationError = unknown
    export type StoreAccountAddressesUpdateMutationVariables = {uid: string;data: CustomerAddressInputRequest}

    export const useStoreAccountAddressesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesUpdate>>, TError,StoreAccountAddressesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeAccountAddressesUpdate>>,
        TError,
        StoreAccountAddressesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreAccountAddressesUpdateMutationOptions(options), queryClient);
    }
    export type storeAccountAddressesDeleteResponse204 = {
  data: void
  status: 204
}

export type storeAccountAddressesDeleteResponseSuccess = (storeAccountAddressesDeleteResponse204) & {
  headers: Headers;
};
;

export type storeAccountAddressesDeleteResponse = (storeAccountAddressesDeleteResponseSuccess)

export const getStoreAccountAddressesDeleteUrl = (uid: string,) => {




  return `/api/v1/store/account/addresses/${uid}`
}

export const storeAccountAddressesDelete = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountAddressesDeleteResponse> => {

  return apiFetch<storeAccountAddressesDeleteResponse>(getStoreAccountAddressesDeleteUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStoreAccountAddressesDeleteMutationKey = () => ['storeAccountAddressesDelete'] as const;

export const getStoreAccountAddressesDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesDelete>>, TError,StoreAccountAddressesDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesDelete>>, TError,StoreAccountAddressesDeleteMutationVariables, TContext> => {

const mutationKey = getStoreAccountAddressesDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeAccountAddressesDelete>>, StoreAccountAddressesDeleteMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  storeAccountAddressesDelete(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreAccountAddressesDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof storeAccountAddressesDelete>>>

    export type StoreAccountAddressesDeleteMutationError = unknown
    export type StoreAccountAddressesDeleteMutationVariables = {uid: string}

    export const useStoreAccountAddressesDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesDelete>>, TError,StoreAccountAddressesDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeAccountAddressesDelete>>,
        TError,
        StoreAccountAddressesDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getStoreAccountAddressesDeleteMutationOptions(options), queryClient);
    }
    export type storeAccountAddressesDefaultResponse200 = {
  data: CustomerAddress[]
  status: 200
}

export type storeAccountAddressesDefaultResponseSuccess = (storeAccountAddressesDefaultResponse200) & {
  headers: Headers;
};
;

export type storeAccountAddressesDefaultResponse = (storeAccountAddressesDefaultResponseSuccess)

export const getStoreAccountAddressesDefaultUrl = (uid: string,) => {




  return `/api/v1/store/account/addresses/${uid}/default`
}

export const storeAccountAddressesDefault = async (uid: string,
    addressDefaultRequest: AddressDefaultRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountAddressesDefaultResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeAccountAddressesDefaultResponse>(getStoreAccountAddressesDefaultUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addressDefaultRequest)
  }
);}





export const getStoreAccountAddressesDefaultMutationKey = () => ['storeAccountAddressesDefault'] as const;

export const getStoreAccountAddressesDefaultMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesDefault>>, TError,StoreAccountAddressesDefaultMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesDefault>>, TError,StoreAccountAddressesDefaultMutationVariables, TContext> => {

const mutationKey = getStoreAccountAddressesDefaultMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeAccountAddressesDefault>>, StoreAccountAddressesDefaultMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  storeAccountAddressesDefault(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreAccountAddressesDefaultMutationResult = NonNullable<Awaited<ReturnType<typeof storeAccountAddressesDefault>>>
    export type StoreAccountAddressesDefaultMutationBody = AddressDefaultRequest
    export type StoreAccountAddressesDefaultMutationError = unknown
    export type StoreAccountAddressesDefaultMutationVariables = {uid: string;data: AddressDefaultRequest}

    export const useStoreAccountAddressesDefault = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountAddressesDefault>>, TError,StoreAccountAddressesDefaultMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeAccountAddressesDefault>>,
        TError,
        StoreAccountAddressesDefaultMutationVariables,
        TContext
      > => {
      return useMutation(getStoreAccountAddressesDefaultMutationOptions(options), queryClient);
    }
    export type storeAccountVehiclesListResponse200 = {
  data: SavedVehicle[]
  status: 200
}

export type storeAccountVehiclesListResponseSuccess = (storeAccountVehiclesListResponse200) & {
  headers: Headers;
};
;

export type storeAccountVehiclesListResponse = (storeAccountVehiclesListResponseSuccess)

export const getStoreAccountVehiclesListUrl = () => {




  return `/api/v1/store/account/vehicles`
}

export const storeAccountVehiclesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountVehiclesListResponse> => {

  return apiFetch<storeAccountVehiclesListResponse>(getStoreAccountVehiclesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreAccountVehiclesListQueryKey = () => {
    return [
    `/api/v1/store/account/vehicles`
    ] as const;
    }


export const getStoreAccountVehiclesListQueryOptions = <TData = Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreAccountVehiclesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeAccountVehiclesList>>> = ({ signal }) => storeAccountVehiclesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreAccountVehiclesListQueryResult = NonNullable<Awaited<ReturnType<typeof storeAccountVehiclesList>>>
export type StoreAccountVehiclesListQueryError = unknown


export function useStoreAccountVehiclesList<TData = Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeAccountVehiclesList>>,
          TError,
          Awaited<ReturnType<typeof storeAccountVehiclesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreAccountVehiclesList<TData = Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeAccountVehiclesList>>,
          TError,
          Awaited<ReturnType<typeof storeAccountVehiclesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreAccountVehiclesList<TData = Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreAccountVehiclesList<TData = Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeAccountVehiclesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreAccountVehiclesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeAccountVehiclesCreateResponse201 = {
  data: SavedVehicle[]
  status: 201
}

export type storeAccountVehiclesCreateResponseSuccess = (storeAccountVehiclesCreateResponse201) & {
  headers: Headers;
};
;

export type storeAccountVehiclesCreateResponse = (storeAccountVehiclesCreateResponseSuccess)

export const getStoreAccountVehiclesCreateUrl = () => {




  return `/api/v1/store/account/vehicles`
}

export const storeAccountVehiclesCreate = async (savedVehicleCreateRequest: SavedVehicleCreateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountVehiclesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeAccountVehiclesCreateResponse>(getStoreAccountVehiclesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(savedVehicleCreateRequest)
  }
);}





export const getStoreAccountVehiclesCreateMutationKey = () => ['storeAccountVehiclesCreate'] as const;

export const getStoreAccountVehiclesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesCreate>>, TError,StoreAccountVehiclesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesCreate>>, TError,StoreAccountVehiclesCreateMutationVariables, TContext> => {

const mutationKey = getStoreAccountVehiclesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeAccountVehiclesCreate>>, StoreAccountVehiclesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeAccountVehiclesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreAccountVehiclesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof storeAccountVehiclesCreate>>>
    export type StoreAccountVehiclesCreateMutationBody = SavedVehicleCreateRequest
    export type StoreAccountVehiclesCreateMutationError = unknown
    export type StoreAccountVehiclesCreateMutationVariables = {data: SavedVehicleCreateRequest}

    export const useStoreAccountVehiclesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesCreate>>, TError,StoreAccountVehiclesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeAccountVehiclesCreate>>,
        TError,
        StoreAccountVehiclesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreAccountVehiclesCreateMutationOptions(options), queryClient);
    }
    export type storeAccountVehiclesUpdateResponse200 = {
  data: SavedVehicle[]
  status: 200
}

export type storeAccountVehiclesUpdateResponseSuccess = (storeAccountVehiclesUpdateResponse200) & {
  headers: Headers;
};
;

export type storeAccountVehiclesUpdateResponse = (storeAccountVehiclesUpdateResponseSuccess)

export const getStoreAccountVehiclesUpdateUrl = (uid: string,) => {




  return `/api/v1/store/account/vehicles/${uid}`
}

export const storeAccountVehiclesUpdate = async (uid: string,
    patchedSavedVehicleUpdateRequest?: PatchedSavedVehicleUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountVehiclesUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeAccountVehiclesUpdateResponse>(getStoreAccountVehiclesUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedSavedVehicleUpdateRequest)
  }
);}





export const getStoreAccountVehiclesUpdateMutationKey = () => ['storeAccountVehiclesUpdate'] as const;

export const getStoreAccountVehiclesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesUpdate>>, TError,StoreAccountVehiclesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesUpdate>>, TError,StoreAccountVehiclesUpdateMutationVariables, TContext> => {

const mutationKey = getStoreAccountVehiclesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeAccountVehiclesUpdate>>, StoreAccountVehiclesUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  storeAccountVehiclesUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreAccountVehiclesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof storeAccountVehiclesUpdate>>>
    export type StoreAccountVehiclesUpdateMutationBody = PatchedSavedVehicleUpdateRequest | undefined
    export type StoreAccountVehiclesUpdateMutationError = unknown
    export type StoreAccountVehiclesUpdateMutationVariables = {uid: string;data?: PatchedSavedVehicleUpdateRequest}

    export const useStoreAccountVehiclesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesUpdate>>, TError,StoreAccountVehiclesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeAccountVehiclesUpdate>>,
        TError,
        StoreAccountVehiclesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreAccountVehiclesUpdateMutationOptions(options), queryClient);
    }
    export type storeAccountVehiclesDeleteResponse204 = {
  data: void
  status: 204
}

export type storeAccountVehiclesDeleteResponseSuccess = (storeAccountVehiclesDeleteResponse204) & {
  headers: Headers;
};
;

export type storeAccountVehiclesDeleteResponse = (storeAccountVehiclesDeleteResponseSuccess)

export const getStoreAccountVehiclesDeleteUrl = (uid: string,) => {




  return `/api/v1/store/account/vehicles/${uid}`
}

export const storeAccountVehiclesDelete = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeAccountVehiclesDeleteResponse> => {

  return apiFetch<storeAccountVehiclesDeleteResponse>(getStoreAccountVehiclesDeleteUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStoreAccountVehiclesDeleteMutationKey = () => ['storeAccountVehiclesDelete'] as const;

export const getStoreAccountVehiclesDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesDelete>>, TError,StoreAccountVehiclesDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesDelete>>, TError,StoreAccountVehiclesDeleteMutationVariables, TContext> => {

const mutationKey = getStoreAccountVehiclesDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeAccountVehiclesDelete>>, StoreAccountVehiclesDeleteMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  storeAccountVehiclesDelete(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreAccountVehiclesDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof storeAccountVehiclesDelete>>>

    export type StoreAccountVehiclesDeleteMutationError = unknown
    export type StoreAccountVehiclesDeleteMutationVariables = {uid: string}

    export const useStoreAccountVehiclesDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeAccountVehiclesDelete>>, TError,StoreAccountVehiclesDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeAccountVehiclesDelete>>,
        TError,
        StoreAccountVehiclesDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getStoreAccountVehiclesDeleteMutationOptions(options), queryClient);
    }
    export type storeBrandsListResponse200 = {
  data: StoreBrand[]
  status: 200
}

export type storeBrandsListResponseSuccess = (storeBrandsListResponse200) & {
  headers: Headers;
};
;

export type storeBrandsListResponse = (storeBrandsListResponseSuccess)

export const getStoreBrandsListUrl = (params?: StoreBrandsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/brands?${stringifiedParams}` : `/api/v1/store/brands`
}

/**
 * Active brands (`?featured=true`: only the featured ones). Public, cached 5 minutes.
 */
export const storeBrandsList = async (params?: StoreBrandsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeBrandsListResponse> => {

  return apiFetch<storeBrandsListResponse>(getStoreBrandsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreBrandsListQueryKey = (params?: StoreBrandsListParams,) => {
    return [
    `/api/v1/store/brands`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreBrandsListQueryOptions = <TData = Awaited<ReturnType<typeof storeBrandsList>>, TError = unknown>(params?: StoreBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreBrandsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeBrandsList>>> = ({ signal }) => storeBrandsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeBrandsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreBrandsListQueryResult = NonNullable<Awaited<ReturnType<typeof storeBrandsList>>>
export type StoreBrandsListQueryError = unknown


export function useStoreBrandsList<TData = Awaited<ReturnType<typeof storeBrandsList>>, TError = unknown>(
 params: undefined |  StoreBrandsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeBrandsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeBrandsList>>,
          TError,
          Awaited<ReturnType<typeof storeBrandsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreBrandsList<TData = Awaited<ReturnType<typeof storeBrandsList>>, TError = unknown>(
 params?: StoreBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeBrandsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeBrandsList>>,
          TError,
          Awaited<ReturnType<typeof storeBrandsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreBrandsList<TData = Awaited<ReturnType<typeof storeBrandsList>>, TError = unknown>(
 params?: StoreBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreBrandsList<TData = Awaited<ReturnType<typeof storeBrandsList>>, TError = unknown>(
 params?: StoreBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreBrandsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCartRetrieveResponse200 = {
  data: Cart
  status: 200
}

export type storeCartRetrieveResponseSuccess = (storeCartRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeCartRetrieveResponse = (storeCartRetrieveResponseSuccess)

export const getStoreCartRetrieveUrl = () => {




  return `/api/v1/store/cart`
}

/**
 * Finds the visitor's cart and answers with the whole re-checked cart.
 */
export const storeCartRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeCartRetrieveResponse> => {

  return apiFetch<storeCartRetrieveResponse>(getStoreCartRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCartRetrieveQueryKey = () => {
    return [
    `/api/v1/store/cart`
    ] as const;
    }


export const getStoreCartRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeCartRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCartRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCartRetrieve>>> = ({ signal }) => storeCartRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCartRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCartRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeCartRetrieve>>>
export type StoreCartRetrieveQueryError = unknown


export function useStoreCartRetrieve<TData = Awaited<ReturnType<typeof storeCartRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCartRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCartRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeCartRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCartRetrieve<TData = Awaited<ReturnType<typeof storeCartRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCartRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCartRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeCartRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCartRetrieve<TData = Awaited<ReturnType<typeof storeCartRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCartRetrieve<TData = Awaited<ReturnType<typeof storeCartRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCartRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCartClearResponse204 = {
  data: void
  status: 204
}

export type storeCartClearResponseSuccess = (storeCartClearResponse204) & {
  headers: Headers;
};
;

export type storeCartClearResponse = (storeCartClearResponseSuccess)

export const getStoreCartClearUrl = () => {




  return `/api/v1/store/cart`
}

/**
 * Finds the visitor's cart and answers with the whole re-checked cart.
 */
export const storeCartClear = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeCartClearResponse> => {

  return apiFetch<storeCartClearResponse>(getStoreCartClearUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStoreCartClearMutationKey = () => ['storeCartClear'] as const;

export const getStoreCartClearMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartClear>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeCartClear>>, TError,void, TContext> => {

const mutationKey = getStoreCartClearMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeCartClear>>, void> = () => {


          return  storeCartClear(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreCartClearMutationResult = NonNullable<Awaited<ReturnType<typeof storeCartClear>>>

    export type StoreCartClearMutationError = unknown


    export const useStoreCartClear = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartClear>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeCartClear>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStoreCartClearMutationOptions(options), queryClient);
    }
    export type storeCartCouponApplyResponse200 = {
  data: Cart
  status: 200
}

export type storeCartCouponApplyResponseSuccess = (storeCartCouponApplyResponse200) & {
  headers: Headers;
};
;

export type storeCartCouponApplyResponse = (storeCartCouponApplyResponseSuccess)

export const getStoreCartCouponApplyUrl = () => {




  return `/api/v1/store/cart/coupon`
}

/**
 * Finds the visitor's cart and answers with the whole re-checked cart.
 */
export const storeCartCouponApply = async (couponCodeRequest: CouponCodeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeCartCouponApplyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeCartCouponApplyResponse>(getStoreCartCouponApplyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(couponCodeRequest)
  }
);}





export const getStoreCartCouponApplyMutationKey = () => ['storeCartCouponApply'] as const;

export const getStoreCartCouponApplyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartCouponApply>>, TError,StoreCartCouponApplyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeCartCouponApply>>, TError,StoreCartCouponApplyMutationVariables, TContext> => {

const mutationKey = getStoreCartCouponApplyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeCartCouponApply>>, StoreCartCouponApplyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeCartCouponApply(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreCartCouponApplyMutationResult = NonNullable<Awaited<ReturnType<typeof storeCartCouponApply>>>
    export type StoreCartCouponApplyMutationBody = CouponCodeRequest
    export type StoreCartCouponApplyMutationError = unknown
    export type StoreCartCouponApplyMutationVariables = {data: CouponCodeRequest}

    export const useStoreCartCouponApply = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartCouponApply>>, TError,StoreCartCouponApplyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeCartCouponApply>>,
        TError,
        StoreCartCouponApplyMutationVariables,
        TContext
      > => {
      return useMutation(getStoreCartCouponApplyMutationOptions(options), queryClient);
    }
    export type storeCartCouponRemoveResponse204 = {
  data: void
  status: 204
}

export type storeCartCouponRemoveResponseSuccess = (storeCartCouponRemoveResponse204) & {
  headers: Headers;
};
;

export type storeCartCouponRemoveResponse = (storeCartCouponRemoveResponseSuccess)

export const getStoreCartCouponRemoveUrl = () => {




  return `/api/v1/store/cart/coupon`
}

/**
 * Finds the visitor's cart and answers with the whole re-checked cart.
 */
export const storeCartCouponRemove = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeCartCouponRemoveResponse> => {

  return apiFetch<storeCartCouponRemoveResponse>(getStoreCartCouponRemoveUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStoreCartCouponRemoveMutationKey = () => ['storeCartCouponRemove'] as const;

export const getStoreCartCouponRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartCouponRemove>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeCartCouponRemove>>, TError,void, TContext> => {

const mutationKey = getStoreCartCouponRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeCartCouponRemove>>, void> = () => {


          return  storeCartCouponRemove(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreCartCouponRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof storeCartCouponRemove>>>

    export type StoreCartCouponRemoveMutationError = unknown


    export const useStoreCartCouponRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartCouponRemove>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeCartCouponRemove>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStoreCartCouponRemoveMutationOptions(options), queryClient);
    }
    export type storeCartAddResponse201 = {
  data: Cart
  status: 201
}

export type storeCartAddResponseSuccess = (storeCartAddResponse201) & {
  headers: Headers;
};
;

export type storeCartAddResponse = (storeCartAddResponseSuccess)

export const getStoreCartAddUrl = () => {




  return `/api/v1/store/cart/items`
}

/**
 * Finds the visitor's cart and answers with the whole re-checked cart.
 */
export const storeCartAdd = async (cartAddRequest: CartAddRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeCartAddResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeCartAddResponse>(getStoreCartAddUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartAddRequest)
  }
);}





export const getStoreCartAddMutationKey = () => ['storeCartAdd'] as const;

export const getStoreCartAddMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartAdd>>, TError,StoreCartAddMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeCartAdd>>, TError,StoreCartAddMutationVariables, TContext> => {

const mutationKey = getStoreCartAddMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeCartAdd>>, StoreCartAddMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeCartAdd(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreCartAddMutationResult = NonNullable<Awaited<ReturnType<typeof storeCartAdd>>>
    export type StoreCartAddMutationBody = CartAddRequest
    export type StoreCartAddMutationError = unknown
    export type StoreCartAddMutationVariables = {data: CartAddRequest}

    export const useStoreCartAdd = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartAdd>>, TError,StoreCartAddMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeCartAdd>>,
        TError,
        StoreCartAddMutationVariables,
        TContext
      > => {
      return useMutation(getStoreCartAddMutationOptions(options), queryClient);
    }
    export type storeCartUpdateResponse200 = {
  data: Cart
  status: 200
}

export type storeCartUpdateResponseSuccess = (storeCartUpdateResponse200) & {
  headers: Headers;
};
;

export type storeCartUpdateResponse = (storeCartUpdateResponseSuccess)

export const getStoreCartUpdateUrl = (variant: string,) => {




  return `/api/v1/store/cart/items/${variant}`
}

/**
 * Finds the visitor's cart and answers with the whole re-checked cart.
 */
export const storeCartUpdate = async (variant: string,
    patchedCartQuantityRequest?: PatchedCartQuantityRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeCartUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeCartUpdateResponse>(getStoreCartUpdateUrl(variant),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCartQuantityRequest)
  }
);}





export const getStoreCartUpdateMutationKey = () => ['storeCartUpdate'] as const;

export const getStoreCartUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartUpdate>>, TError,StoreCartUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeCartUpdate>>, TError,StoreCartUpdateMutationVariables, TContext> => {

const mutationKey = getStoreCartUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeCartUpdate>>, StoreCartUpdateMutationVariables> = (props) => {
          const {variant,data} = props ?? {};

          return  storeCartUpdate(variant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreCartUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof storeCartUpdate>>>
    export type StoreCartUpdateMutationBody = PatchedCartQuantityRequest | undefined
    export type StoreCartUpdateMutationError = unknown
    export type StoreCartUpdateMutationVariables = {variant: string;data?: PatchedCartQuantityRequest}

    export const useStoreCartUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartUpdate>>, TError,StoreCartUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeCartUpdate>>,
        TError,
        StoreCartUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreCartUpdateMutationOptions(options), queryClient);
    }
    export type storeCartRemoveResponse204 = {
  data: void
  status: 204
}

export type storeCartRemoveResponseSuccess = (storeCartRemoveResponse204) & {
  headers: Headers;
};
;

export type storeCartRemoveResponse = (storeCartRemoveResponseSuccess)

export const getStoreCartRemoveUrl = (variant: string,) => {




  return `/api/v1/store/cart/items/${variant}`
}

/**
 * Finds the visitor's cart and answers with the whole re-checked cart.
 */
export const storeCartRemove = async (variant: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeCartRemoveResponse> => {

  return apiFetch<storeCartRemoveResponse>(getStoreCartRemoveUrl(variant),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStoreCartRemoveMutationKey = () => ['storeCartRemove'] as const;

export const getStoreCartRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartRemove>>, TError,StoreCartRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeCartRemove>>, TError,StoreCartRemoveMutationVariables, TContext> => {

const mutationKey = getStoreCartRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeCartRemove>>, StoreCartRemoveMutationVariables> = (props) => {
          const {variant} = props ?? {};

          return  storeCartRemove(variant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreCartRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof storeCartRemove>>>

    export type StoreCartRemoveMutationError = unknown
    export type StoreCartRemoveMutationVariables = {variant: string}

    export const useStoreCartRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartRemove>>, TError,StoreCartRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeCartRemove>>,
        TError,
        StoreCartRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getStoreCartRemoveMutationOptions(options), queryClient);
    }
    export type storeCartVehicleResponse200 = {
  data: Cart
  status: 200
}

export type storeCartVehicleResponseSuccess = (storeCartVehicleResponse200) & {
  headers: Headers;
};
;

export type storeCartVehicleResponse = (storeCartVehicleResponseSuccess)

export const getStoreCartVehicleUrl = () => {




  return `/api/v1/store/cart/vehicle`
}

/**
 * Finds the visitor's cart and answers with the whole re-checked cart.
 */
export const storeCartVehicle = async (cartVehicleRequest: CartVehicleRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeCartVehicleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeCartVehicleResponse>(getStoreCartVehicleUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartVehicleRequest)
  }
);}





export const getStoreCartVehicleMutationKey = () => ['storeCartVehicle'] as const;

export const getStoreCartVehicleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartVehicle>>, TError,StoreCartVehicleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeCartVehicle>>, TError,StoreCartVehicleMutationVariables, TContext> => {

const mutationKey = getStoreCartVehicleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeCartVehicle>>, StoreCartVehicleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeCartVehicle(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreCartVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof storeCartVehicle>>>
    export type StoreCartVehicleMutationBody = CartVehicleRequest
    export type StoreCartVehicleMutationError = unknown
    export type StoreCartVehicleMutationVariables = {data: CartVehicleRequest}

    export const useStoreCartVehicle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCartVehicle>>, TError,StoreCartVehicleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeCartVehicle>>,
        TError,
        StoreCartVehicleMutationVariables,
        TContext
      > => {
      return useMutation(getStoreCartVehicleMutationOptions(options), queryClient);
    }
    export type storeCategoriesTreeResponse200 = {
  data: TreeNode[]
  status: 200
}

export type storeCategoriesTreeResponseSuccess = (storeCategoriesTreeResponse200) & {
  headers: Headers;
};
;

export type storeCategoriesTreeResponse = (storeCategoriesTreeResponseSuccess)

export const getStoreCategoriesTreeUrl = (params?: StoreCategoriesTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/categories?${stringifiedParams}` : `/api/v1/store/categories`
}

/**
 * Active categories as a tree (`?menu=true`: only those shown in the menu). Public, cached 5 minutes.
 */
export const storeCategoriesTree = async (params?: StoreCategoriesTreeParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeCategoriesTreeResponse> => {

  return apiFetch<storeCategoriesTreeResponse>(getStoreCategoriesTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCategoriesTreeQueryKey = (params?: StoreCategoriesTreeParams,) => {
    return [
    `/api/v1/store/categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreCategoriesTreeQueryOptions = <TData = Awaited<ReturnType<typeof storeCategoriesTree>>, TError = unknown>(params?: StoreCategoriesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCategoriesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCategoriesTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCategoriesTree>>> = ({ signal }) => storeCategoriesTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCategoriesTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCategoriesTreeQueryResult = NonNullable<Awaited<ReturnType<typeof storeCategoriesTree>>>
export type StoreCategoriesTreeQueryError = unknown


export function useStoreCategoriesTree<TData = Awaited<ReturnType<typeof storeCategoriesTree>>, TError = unknown>(
 params: undefined |  StoreCategoriesTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCategoriesTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCategoriesTree>>,
          TError,
          Awaited<ReturnType<typeof storeCategoriesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCategoriesTree<TData = Awaited<ReturnType<typeof storeCategoriesTree>>, TError = unknown>(
 params?: StoreCategoriesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCategoriesTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCategoriesTree>>,
          TError,
          Awaited<ReturnType<typeof storeCategoriesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCategoriesTree<TData = Awaited<ReturnType<typeof storeCategoriesTree>>, TError = unknown>(
 params?: StoreCategoriesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCategoriesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCategoriesTree<TData = Awaited<ReturnType<typeof storeCategoriesTree>>, TError = unknown>(
 params?: StoreCategoriesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCategoriesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCategoriesTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCheckoutPlaceResponse201 = {
  data: Placed
  status: 201
}

export type storeCheckoutPlaceResponseSuccess = (storeCheckoutPlaceResponse201) & {
  headers: Headers;
};
;

export type storeCheckoutPlaceResponse = (storeCheckoutPlaceResponseSuccess)

export const getStoreCheckoutPlaceUrl = () => {




  return `/api/v1/store/checkout`
}

export const storeCheckoutPlace = async (checkoutRequest: CheckoutRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeCheckoutPlaceResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeCheckoutPlaceResponse>(getStoreCheckoutPlaceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(checkoutRequest)
  }
);}





export const getStoreCheckoutPlaceMutationKey = () => ['storeCheckoutPlace'] as const;

export const getStoreCheckoutPlaceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCheckoutPlace>>, TError,StoreCheckoutPlaceMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeCheckoutPlace>>, TError,StoreCheckoutPlaceMutationVariables, TContext> => {

const mutationKey = getStoreCheckoutPlaceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeCheckoutPlace>>, StoreCheckoutPlaceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeCheckoutPlace(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreCheckoutPlaceMutationResult = NonNullable<Awaited<ReturnType<typeof storeCheckoutPlace>>>
    export type StoreCheckoutPlaceMutationBody = CheckoutRequest
    export type StoreCheckoutPlaceMutationError = unknown
    export type StoreCheckoutPlaceMutationVariables = {data: CheckoutRequest}

    export const useStoreCheckoutPlace = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeCheckoutPlace>>, TError,StoreCheckoutPlaceMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeCheckoutPlace>>,
        TError,
        StoreCheckoutPlaceMutationVariables,
        TContext
      > => {
      return useMutation(getStoreCheckoutPlaceMutationOptions(options), queryClient);
    }
    export type storeCheckoutPreviewResponse200 = {
  data: CheckoutPreview
  status: 200
}

export type storeCheckoutPreviewResponseSuccess = (storeCheckoutPreviewResponse200) & {
  headers: Headers;
};
;

export type storeCheckoutPreviewResponse = (storeCheckoutPreviewResponseSuccess)

export const getStoreCheckoutPreviewUrl = (params?: StoreCheckoutPreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/checkout/preview?${stringifiedParams}` : `/api/v1/store/checkout/preview`
}

export const storeCheckoutPreview = async (params?: StoreCheckoutPreviewParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeCheckoutPreviewResponse> => {

  return apiFetch<storeCheckoutPreviewResponse>(getStoreCheckoutPreviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCheckoutPreviewQueryKey = (params?: StoreCheckoutPreviewParams,) => {
    return [
    `/api/v1/store/checkout/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreCheckoutPreviewQueryOptions = <TData = Awaited<ReturnType<typeof storeCheckoutPreview>>, TError = unknown>(params?: StoreCheckoutPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCheckoutPreview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCheckoutPreviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCheckoutPreview>>> = ({ signal }) => storeCheckoutPreview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCheckoutPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCheckoutPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof storeCheckoutPreview>>>
export type StoreCheckoutPreviewQueryError = unknown


export function useStoreCheckoutPreview<TData = Awaited<ReturnType<typeof storeCheckoutPreview>>, TError = unknown>(
 params: undefined |  StoreCheckoutPreviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCheckoutPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCheckoutPreview>>,
          TError,
          Awaited<ReturnType<typeof storeCheckoutPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCheckoutPreview<TData = Awaited<ReturnType<typeof storeCheckoutPreview>>, TError = unknown>(
 params?: StoreCheckoutPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCheckoutPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCheckoutPreview>>,
          TError,
          Awaited<ReturnType<typeof storeCheckoutPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCheckoutPreview<TData = Awaited<ReturnType<typeof storeCheckoutPreview>>, TError = unknown>(
 params?: StoreCheckoutPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCheckoutPreview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCheckoutPreview<TData = Awaited<ReturnType<typeof storeCheckoutPreview>>, TError = unknown>(
 params?: StoreCheckoutPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCheckoutPreview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCheckoutPreviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsBannersResponse200 = {
  data: StoreBanner[]
  status: 200
}

export type storeCmsBannersResponseSuccess = (storeCmsBannersResponse200) & {
  headers: Headers;
};
;

export type storeCmsBannersResponse = (storeCmsBannersResponseSuccess)

export const getStoreCmsBannersUrl = (params: StoreCmsBannersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/cms/banners?${stringifiedParams}` : `/api/v1/store/cms/banners`
}

/**
 * Banners showing now in a placement.
 */
export const storeCmsBanners = async (params: StoreCmsBannersParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsBannersResponse> => {

  return apiFetch<storeCmsBannersResponse>(getStoreCmsBannersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsBannersQueryKey = (params?: StoreCmsBannersParams,) => {
    return [
    `/api/v1/store/cms/banners`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreCmsBannersQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsBanners>>, TError = unknown>(params: StoreCmsBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBanners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsBannersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsBanners>>> = ({ signal }) => storeCmsBanners(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsBanners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsBannersQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsBanners>>>
export type StoreCmsBannersQueryError = unknown


export function useStoreCmsBanners<TData = Awaited<ReturnType<typeof storeCmsBanners>>, TError = unknown>(
 params: StoreCmsBannersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBanners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsBanners>>,
          TError,
          Awaited<ReturnType<typeof storeCmsBanners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsBanners<TData = Awaited<ReturnType<typeof storeCmsBanners>>, TError = unknown>(
 params: StoreCmsBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBanners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsBanners>>,
          TError,
          Awaited<ReturnType<typeof storeCmsBanners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsBanners<TData = Awaited<ReturnType<typeof storeCmsBanners>>, TError = unknown>(
 params: StoreCmsBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBanners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsBanners<TData = Awaited<ReturnType<typeof storeCmsBanners>>, TError = unknown>(
 params: StoreCmsBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBanners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsBannersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsBlogCategoriesResponse200 = {
  data: StoreBlogCategory[]
  status: 200
}

export type storeCmsBlogCategoriesResponseSuccess = (storeCmsBlogCategoriesResponse200) & {
  headers: Headers;
};
;

export type storeCmsBlogCategoriesResponse = (storeCmsBlogCategoriesResponseSuccess)

export const getStoreCmsBlogCategoriesUrl = () => {




  return `/api/v1/store/cms/blog/categories`
}

export const storeCmsBlogCategories = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsBlogCategoriesResponse> => {

  return apiFetch<storeCmsBlogCategoriesResponse>(getStoreCmsBlogCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsBlogCategoriesQueryKey = () => {
    return [
    `/api/v1/store/cms/blog/categories`
    ] as const;
    }


export const getStoreCmsBlogCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsBlogCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsBlogCategories>>> = ({ signal }) => storeCmsBlogCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsBlogCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsBlogCategories>>>
export type StoreCmsBlogCategoriesQueryError = unknown


export function useStoreCmsBlogCategories<TData = Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsBlogCategories>>,
          TError,
          Awaited<ReturnType<typeof storeCmsBlogCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsBlogCategories<TData = Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsBlogCategories>>,
          TError,
          Awaited<ReturnType<typeof storeCmsBlogCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsBlogCategories<TData = Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsBlogCategories<TData = Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsBlogCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsPostsResponse200 = {
  data: StorePostPage
  status: 200
}

export type storeCmsPostsResponseSuccess = (storeCmsPostsResponse200) & {
  headers: Headers;
};
;

export type storeCmsPostsResponse = (storeCmsPostsResponseSuccess)

export const getStoreCmsPostsUrl = (params?: StoreCmsPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/cms/blog/posts?${stringifiedParams}` : `/api/v1/store/cms/blog/posts`
}

/**
 * Live posts, newest first (`?category=<slug>` includes subcategories, `?tag=<slug>`, `?featured=true`).
 */
export const storeCmsPosts = async (params?: StoreCmsPostsParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsPostsResponse> => {

  return apiFetch<storeCmsPostsResponse>(getStoreCmsPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsPostsQueryKey = (params?: StoreCmsPostsParams,) => {
    return [
    `/api/v1/store/cms/blog/posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreCmsPostsQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsPosts>>, TError = unknown>(params?: StoreCmsPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPosts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsPosts>>> = ({ signal }) => storeCmsPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsPostsQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsPosts>>>
export type StoreCmsPostsQueryError = unknown


export function useStoreCmsPosts<TData = Awaited<ReturnType<typeof storeCmsPosts>>, TError = unknown>(
 params: undefined |  StoreCmsPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPosts>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPosts<TData = Awaited<ReturnType<typeof storeCmsPosts>>, TError = unknown>(
 params?: StoreCmsPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPosts>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPosts<TData = Awaited<ReturnType<typeof storeCmsPosts>>, TError = unknown>(
 params?: StoreCmsPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPosts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsPosts<TData = Awaited<ReturnType<typeof storeCmsPosts>>, TError = unknown>(
 params?: StoreCmsPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPosts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsPostResponse200 = {
  data: StorePost
  status: 200
}

export type storeCmsPostResponseSuccess = (storeCmsPostResponse200) & {
  headers: Headers;
};
;

export type storeCmsPostResponse = (storeCmsPostResponseSuccess)

export const getStoreCmsPostUrl = (slug: string,) => {




  return `/api/v1/store/cms/blog/posts/${slug}`
}

export const storeCmsPost = async (slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsPostResponse> => {

  return apiFetch<storeCmsPostResponse>(getStoreCmsPostUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsPostQueryKey = (slug: string,) => {
    return [
    `/api/v1/store/cms/blog/posts/${slug}`
    ] as const;
    }


export const getStoreCmsPostQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsPost>>, TError = unknown>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPost>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsPostQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsPost>>> = ({ signal }) => storeCmsPost(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsPostQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsPost>>>
export type StoreCmsPostQueryError = unknown


export function useStoreCmsPost<TData = Awaited<ReturnType<typeof storeCmsPost>>, TError = unknown>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPost>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPost>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPost<TData = Awaited<ReturnType<typeof storeCmsPost>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPost>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPost>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPost<TData = Awaited<ReturnType<typeof storeCmsPost>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPost>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsPost<TData = Awaited<ReturnType<typeof storeCmsPost>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPost>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsPostQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsPostSlugsResponse200 = {
  data: string[]
  status: 200
}

export type storeCmsPostSlugsResponseSuccess = (storeCmsPostSlugsResponse200) & {
  headers: Headers;
};
;

export type storeCmsPostSlugsResponse = (storeCmsPostSlugsResponseSuccess)

export const getStoreCmsPostSlugsUrl = () => {




  return `/api/v1/store/cms/blog/posts/slugs`
}

export const storeCmsPostSlugs = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsPostSlugsResponse> => {

  return apiFetch<storeCmsPostSlugsResponse>(getStoreCmsPostSlugsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsPostSlugsQueryKey = () => {
    return [
    `/api/v1/store/cms/blog/posts/slugs`
    ] as const;
    }


export const getStoreCmsPostSlugsQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsPostSlugsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsPostSlugs>>> = ({ signal }) => storeCmsPostSlugs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsPostSlugsQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsPostSlugs>>>
export type StoreCmsPostSlugsQueryError = unknown


export function useStoreCmsPostSlugs<TData = Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPostSlugs>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPostSlugs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPostSlugs<TData = Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPostSlugs>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPostSlugs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPostSlugs<TData = Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsPostSlugs<TData = Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPostSlugs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsPostSlugsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsBlogTagsResponse200 = {
  data: StoreCategoryRef[]
  status: 200
}

export type storeCmsBlogTagsResponseSuccess = (storeCmsBlogTagsResponse200) & {
  headers: Headers;
};
;

export type storeCmsBlogTagsResponse = (storeCmsBlogTagsResponseSuccess)

export const getStoreCmsBlogTagsUrl = () => {




  return `/api/v1/store/cms/blog/tags`
}

/**
 * Tags that have at least one live post.
 */
export const storeCmsBlogTags = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsBlogTagsResponse> => {

  return apiFetch<storeCmsBlogTagsResponse>(getStoreCmsBlogTagsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsBlogTagsQueryKey = () => {
    return [
    `/api/v1/store/cms/blog/tags`
    ] as const;
    }


export const getStoreCmsBlogTagsQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsBlogTags>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsBlogTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsBlogTags>>> = ({ signal }) => storeCmsBlogTags({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsBlogTagsQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsBlogTags>>>
export type StoreCmsBlogTagsQueryError = unknown


export function useStoreCmsBlogTags<TData = Awaited<ReturnType<typeof storeCmsBlogTags>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsBlogTags>>,
          TError,
          Awaited<ReturnType<typeof storeCmsBlogTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsBlogTags<TData = Awaited<ReturnType<typeof storeCmsBlogTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsBlogTags>>,
          TError,
          Awaited<ReturnType<typeof storeCmsBlogTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsBlogTags<TData = Awaited<ReturnType<typeof storeCmsBlogTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsBlogTags<TData = Awaited<ReturnType<typeof storeCmsBlogTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsBlogTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsBlogTagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsFaqsResponse200 = {
  data: StoreFaqCategory[]
  status: 200
}

export type storeCmsFaqsResponseSuccess = (storeCmsFaqsResponse200) & {
  headers: Headers;
};
;

export type storeCmsFaqsResponse = (storeCmsFaqsResponseSuccess)

export const getStoreCmsFaqsUrl = (params?: StoreCmsFaqsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/cms/faqs?${stringifiedParams}` : `/api/v1/store/cms/faqs`
}

/**
 * Published FAQs by category (`?audience=customer|vendor`; "everyone" categories are always included).
 */
export const storeCmsFaqs = async (params?: StoreCmsFaqsParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsFaqsResponse> => {

  return apiFetch<storeCmsFaqsResponse>(getStoreCmsFaqsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsFaqsQueryKey = (params?: StoreCmsFaqsParams,) => {
    return [
    `/api/v1/store/cms/faqs`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreCmsFaqsQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsFaqs>>, TError = unknown>(params?: StoreCmsFaqsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsFaqs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsFaqsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsFaqs>>> = ({ signal }) => storeCmsFaqs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsFaqs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsFaqsQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsFaqs>>>
export type StoreCmsFaqsQueryError = unknown


export function useStoreCmsFaqs<TData = Awaited<ReturnType<typeof storeCmsFaqs>>, TError = unknown>(
 params: undefined |  StoreCmsFaqsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsFaqs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsFaqs>>,
          TError,
          Awaited<ReturnType<typeof storeCmsFaqs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsFaqs<TData = Awaited<ReturnType<typeof storeCmsFaqs>>, TError = unknown>(
 params?: StoreCmsFaqsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsFaqs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsFaqs>>,
          TError,
          Awaited<ReturnType<typeof storeCmsFaqs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsFaqs<TData = Awaited<ReturnType<typeof storeCmsFaqs>>, TError = unknown>(
 params?: StoreCmsFaqsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsFaqs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsFaqs<TData = Awaited<ReturnType<typeof storeCmsFaqs>>, TError = unknown>(
 params?: StoreCmsFaqsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsFaqs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsFaqsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsPagesListResponse200 = {
  data: StorePageSummary[]
  status: 200
}

export type storeCmsPagesListResponseSuccess = (storeCmsPagesListResponse200) & {
  headers: Headers;
};
;

export type storeCmsPagesListResponse = (storeCmsPagesListResponseSuccess)

export const getStoreCmsPagesListUrl = (params?: StoreCmsPagesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/cms/pages?${stringifiedParams}` : `/api/v1/store/cms/pages`
}

/**
 * Published pages (`?type=page|policy`, `?footer=true`).
 */
export const storeCmsPagesList = async (params?: StoreCmsPagesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsPagesListResponse> => {

  return apiFetch<storeCmsPagesListResponse>(getStoreCmsPagesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsPagesListQueryKey = (params?: StoreCmsPagesListParams,) => {
    return [
    `/api/v1/store/cms/pages`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreCmsPagesListQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsPagesList>>, TError = unknown>(params?: StoreCmsPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsPagesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsPagesList>>> = ({ signal }) => storeCmsPagesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsPagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsPagesListQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsPagesList>>>
export type StoreCmsPagesListQueryError = unknown


export function useStoreCmsPagesList<TData = Awaited<ReturnType<typeof storeCmsPagesList>>, TError = unknown>(
 params: undefined |  StoreCmsPagesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPagesList>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPagesList<TData = Awaited<ReturnType<typeof storeCmsPagesList>>, TError = unknown>(
 params?: StoreCmsPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPagesList>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPagesList<TData = Awaited<ReturnType<typeof storeCmsPagesList>>, TError = unknown>(
 params?: StoreCmsPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsPagesList<TData = Awaited<ReturnType<typeof storeCmsPagesList>>, TError = unknown>(
 params?: StoreCmsPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsPagesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsPageResponse200 = {
  data: StorePage
  status: 200
}

export type storeCmsPageResponseSuccess = (storeCmsPageResponse200) & {
  headers: Headers;
};
;

export type storeCmsPageResponse = (storeCmsPageResponseSuccess)

export const getStoreCmsPageUrl = (slug: string,) => {




  return `/api/v1/store/cms/pages/${slug}`
}

export const storeCmsPage = async (slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsPageResponse> => {

  return apiFetch<storeCmsPageResponse>(getStoreCmsPageUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsPageQueryKey = (slug: string,) => {
    return [
    `/api/v1/store/cms/pages/${slug}`
    ] as const;
    }


export const getStoreCmsPageQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsPage>>, TError = unknown>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsPageQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsPage>>> = ({ signal }) => storeCmsPage(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsPage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsPageQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsPage>>>
export type StoreCmsPageQueryError = unknown


export function useStoreCmsPage<TData = Awaited<ReturnType<typeof storeCmsPage>>, TError = unknown>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPage>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPage<TData = Awaited<ReturnType<typeof storeCmsPage>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPage>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPage<TData = Awaited<ReturnType<typeof storeCmsPage>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsPage<TData = Awaited<ReturnType<typeof storeCmsPage>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsPageQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeCmsPageSlugsResponse200 = {
  data: string[]
  status: 200
}

export type storeCmsPageSlugsResponseSuccess = (storeCmsPageSlugsResponse200) & {
  headers: Headers;
};
;

export type storeCmsPageSlugsResponse = (storeCmsPageSlugsResponseSuccess)

export const getStoreCmsPageSlugsUrl = (params?: StoreCmsPageSlugsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/cms/pages/slugs?${stringifiedParams}` : `/api/v1/store/cms/pages/slugs`
}

export const storeCmsPageSlugs = async (params?: StoreCmsPageSlugsParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeCmsPageSlugsResponse> => {

  return apiFetch<storeCmsPageSlugsResponse>(getStoreCmsPageSlugsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreCmsPageSlugsQueryKey = (params?: StoreCmsPageSlugsParams,) => {
    return [
    `/api/v1/store/cms/pages/slugs`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreCmsPageSlugsQueryOptions = <TData = Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError = unknown>(params?: StoreCmsPageSlugsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreCmsPageSlugsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeCmsPageSlugs>>> = ({ signal }) => storeCmsPageSlugs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreCmsPageSlugsQueryResult = NonNullable<Awaited<ReturnType<typeof storeCmsPageSlugs>>>
export type StoreCmsPageSlugsQueryError = unknown


export function useStoreCmsPageSlugs<TData = Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError = unknown>(
 params: undefined |  StoreCmsPageSlugsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPageSlugs>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPageSlugs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPageSlugs<TData = Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError = unknown>(
 params?: StoreCmsPageSlugsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeCmsPageSlugs>>,
          TError,
          Awaited<ReturnType<typeof storeCmsPageSlugs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreCmsPageSlugs<TData = Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError = unknown>(
 params?: StoreCmsPageSlugsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreCmsPageSlugs<TData = Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError = unknown>(
 params?: StoreCmsPageSlugsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeCmsPageSlugs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreCmsPageSlugsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeFeaturesRetrieveResponse200 = {
  data: StoreFeaturesRetrieve200
  status: 200
}

export type storeFeaturesRetrieveResponseSuccess = (storeFeaturesRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeFeaturesRetrieveResponse = (storeFeaturesRetrieveResponseSuccess)

export const getStoreFeaturesRetrieveUrl = () => {




  return `/api/v1/store/features`
}

/**
 * Flags exposed to the storefront (platform values).
 */
export const storeFeaturesRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeFeaturesRetrieveResponse> => {

  return apiFetch<storeFeaturesRetrieveResponse>(getStoreFeaturesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreFeaturesRetrieveQueryKey = () => {
    return [
    `/api/v1/store/features`
    ] as const;
    }


export const getStoreFeaturesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreFeaturesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeFeaturesRetrieve>>> = ({ signal }) => storeFeaturesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreFeaturesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeFeaturesRetrieve>>>
export type StoreFeaturesRetrieveQueryError = unknown


export function useStoreFeaturesRetrieve<TData = Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeFeaturesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeFeaturesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreFeaturesRetrieve<TData = Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeFeaturesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeFeaturesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreFeaturesRetrieve<TData = Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreFeaturesRetrieve<TData = Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreFeaturesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeFeaturesRenderingRetrieveResponse200 = {
  data: RenderingModes
  status: 200
}

export type storeFeaturesRenderingRetrieveResponseSuccess = (storeFeaturesRenderingRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeFeaturesRenderingRetrieveResponse = (storeFeaturesRenderingRetrieveResponseSuccess)

export const getStoreFeaturesRenderingRetrieveUrl = () => {




  return `/api/v1/store/features/rendering`
}

/**
 * Rendering mode per storefront route group, read by the storefront middleware (§18.3).
 */
export const storeFeaturesRenderingRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeFeaturesRenderingRetrieveResponse> => {

  return apiFetch<storeFeaturesRenderingRetrieveResponse>(getStoreFeaturesRenderingRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreFeaturesRenderingRetrieveQueryKey = () => {
    return [
    `/api/v1/store/features/rendering`
    ] as const;
    }


export const getStoreFeaturesRenderingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreFeaturesRenderingRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>> = ({ signal }) => storeFeaturesRenderingRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreFeaturesRenderingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>>
export type StoreFeaturesRenderingRetrieveQueryError = unknown


export function useStoreFeaturesRenderingRetrieve<TData = Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreFeaturesRenderingRetrieve<TData = Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreFeaturesRenderingRetrieve<TData = Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreFeaturesRenderingRetrieve<TData = Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeFeaturesRenderingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreFeaturesRenderingRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeGeoCountriesListResponse200 = {
  data: Country[]
  status: 200
}

export type storeGeoCountriesListResponseSuccess = (storeGeoCountriesListResponse200) & {
  headers: Headers;
};
;

export type storeGeoCountriesListResponse = (storeGeoCountriesListResponseSuccess)

export const getStoreGeoCountriesListUrl = () => {




  return `/api/v1/store/geo/countries`
}

/**
 * Countries customers and vendors can pick (active only), by name.
 */
export const storeGeoCountriesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeGeoCountriesListResponse> => {

  return apiFetch<storeGeoCountriesListResponse>(getStoreGeoCountriesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreGeoCountriesListQueryKey = () => {
    return [
    `/api/v1/store/geo/countries`
    ] as const;
    }


export const getStoreGeoCountriesListQueryOptions = <TData = Awaited<ReturnType<typeof storeGeoCountriesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoCountriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreGeoCountriesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeGeoCountriesList>>> = ({ signal }) => storeGeoCountriesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeGeoCountriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreGeoCountriesListQueryResult = NonNullable<Awaited<ReturnType<typeof storeGeoCountriesList>>>
export type StoreGeoCountriesListQueryError = unknown


export function useStoreGeoCountriesList<TData = Awaited<ReturnType<typeof storeGeoCountriesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoCountriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeGeoCountriesList>>,
          TError,
          Awaited<ReturnType<typeof storeGeoCountriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreGeoCountriesList<TData = Awaited<ReturnType<typeof storeGeoCountriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoCountriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeGeoCountriesList>>,
          TError,
          Awaited<ReturnType<typeof storeGeoCountriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreGeoCountriesList<TData = Awaited<ReturnType<typeof storeGeoCountriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoCountriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreGeoCountriesList<TData = Awaited<ReturnType<typeof storeGeoCountriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoCountriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreGeoCountriesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeGeoStatesListResponse200 = {
  data: State[]
  status: 200
}

export type storeGeoStatesListResponseSuccess = (storeGeoStatesListResponse200) & {
  headers: Headers;
};
;

export type storeGeoStatesListResponse = (storeGeoStatesListResponseSuccess)

export const getStoreGeoStatesListUrl = (params: StoreGeoStatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/geo/states?${stringifiedParams}` : `/api/v1/store/geo/states`
}

/**
 * Active states/regions of one active country, by name (`?country=IN`).
 */
export const storeGeoStatesList = async (params: StoreGeoStatesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeGeoStatesListResponse> => {

  return apiFetch<storeGeoStatesListResponse>(getStoreGeoStatesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreGeoStatesListQueryKey = (params?: StoreGeoStatesListParams,) => {
    return [
    `/api/v1/store/geo/states`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreGeoStatesListQueryOptions = <TData = Awaited<ReturnType<typeof storeGeoStatesList>>, TError = unknown>(params: StoreGeoStatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoStatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreGeoStatesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeGeoStatesList>>> = ({ signal }) => storeGeoStatesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeGeoStatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreGeoStatesListQueryResult = NonNullable<Awaited<ReturnType<typeof storeGeoStatesList>>>
export type StoreGeoStatesListQueryError = unknown


export function useStoreGeoStatesList<TData = Awaited<ReturnType<typeof storeGeoStatesList>>, TError = unknown>(
 params: StoreGeoStatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoStatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeGeoStatesList>>,
          TError,
          Awaited<ReturnType<typeof storeGeoStatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreGeoStatesList<TData = Awaited<ReturnType<typeof storeGeoStatesList>>, TError = unknown>(
 params: StoreGeoStatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoStatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeGeoStatesList>>,
          TError,
          Awaited<ReturnType<typeof storeGeoStatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreGeoStatesList<TData = Awaited<ReturnType<typeof storeGeoStatesList>>, TError = unknown>(
 params: StoreGeoStatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoStatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreGeoStatesList<TData = Awaited<ReturnType<typeof storeGeoStatesList>>, TError = unknown>(
 params: StoreGeoStatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeGeoStatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreGeoStatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeHomeResponse200 = {
  data: StoreHome
  status: 200
}

export type storeHomeResponseSuccess = (storeHomeResponse200) & {
  headers: Headers;
};
;

export type storeHomeResponse = (storeHomeResponseSuccess)

export const getStoreHomeUrl = () => {




  return `/api/v1/store/home`
}

/**
 * The home page's catalogue blocks: menu categories, featured brands, deals and new arrivals. Banners come from
 * the CMS (`cms/banners?placement=home_hero`) when it is installed.
 */
export const storeHome = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeHomeResponse> => {

  return apiFetch<storeHomeResponse>(getStoreHomeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreHomeQueryKey = () => {
    return [
    `/api/v1/store/home`
    ] as const;
    }


export const getStoreHomeQueryOptions = <TData = Awaited<ReturnType<typeof storeHome>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreHomeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeHome>>> = ({ signal }) => storeHome({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeHome>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreHomeQueryResult = NonNullable<Awaited<ReturnType<typeof storeHome>>>
export type StoreHomeQueryError = unknown


export function useStoreHome<TData = Awaited<ReturnType<typeof storeHome>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeHome>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeHome>>,
          TError,
          Awaited<ReturnType<typeof storeHome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreHome<TData = Awaited<ReturnType<typeof storeHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeHome>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeHome>>,
          TError,
          Awaited<ReturnType<typeof storeHome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreHome<TData = Awaited<ReturnType<typeof storeHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreHome<TData = Awaited<ReturnType<typeof storeHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreHomeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeInvoicesPdfResponse200 = {
  data: Blob
  status: 200
}

export type storeInvoicesPdfResponseSuccess = (storeInvoicesPdfResponse200) & {
  headers: Headers;
};
;

export type storeInvoicesPdfResponse = (storeInvoicesPdfResponseSuccess)

export const getStoreInvoicesPdfUrl = (uid: string,) => {




  return `/api/v1/store/invoices/${uid}/pdf`
}

export const storeInvoicesPdf = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeInvoicesPdfResponse> => {

  return apiFetch<storeInvoicesPdfResponse>(getStoreInvoicesPdfUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreInvoicesPdfQueryKey = (uid: string,) => {
    return [
    `/api/v1/store/invoices/${uid}/pdf`
    ] as const;
    }


export const getStoreInvoicesPdfQueryOptions = <TData = Awaited<ReturnType<typeof storeInvoicesPdf>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreInvoicesPdfQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeInvoicesPdf>>> = ({ signal }) => storeInvoicesPdf(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeInvoicesPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreInvoicesPdfQueryResult = NonNullable<Awaited<ReturnType<typeof storeInvoicesPdf>>>
export type StoreInvoicesPdfQueryError = unknown


export function useStoreInvoicesPdf<TData = Awaited<ReturnType<typeof storeInvoicesPdf>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeInvoicesPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeInvoicesPdf>>,
          TError,
          Awaited<ReturnType<typeof storeInvoicesPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreInvoicesPdf<TData = Awaited<ReturnType<typeof storeInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeInvoicesPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeInvoicesPdf>>,
          TError,
          Awaited<ReturnType<typeof storeInvoicesPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreInvoicesPdf<TData = Awaited<ReturnType<typeof storeInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreInvoicesPdf<TData = Awaited<ReturnType<typeof storeInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreInvoicesPdfQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeMeRetrieveResponse200 = {
  data: StoreMe
  status: 200
}

export type storeMeRetrieveResponseSuccess = (storeMeRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeMeRetrieveResponse = (storeMeRetrieveResponseSuccess)

export const getStoreMeRetrieveUrl = () => {




  return `/api/v1/store/me`
}

/**
 * PATCH /me: update the logged-in user's own profile.
 */
export const storeMeRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeMeRetrieveResponse> => {

  return apiFetch<storeMeRetrieveResponse>(getStoreMeRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreMeRetrieveQueryKey = () => {
    return [
    `/api/v1/store/me`
    ] as const;
    }


export const getStoreMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeMeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreMeRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeMeRetrieve>>> = ({ signal }) => storeMeRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeMeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeMeRetrieve>>>
export type StoreMeRetrieveQueryError = unknown


export function useStoreMeRetrieve<TData = Awaited<ReturnType<typeof storeMeRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeMeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreMeRetrieve<TData = Awaited<ReturnType<typeof storeMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeMeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreMeRetrieve<TData = Awaited<ReturnType<typeof storeMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreMeRetrieve<TData = Awaited<ReturnType<typeof storeMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeMePartialUpdateResponse200 = {
  data: StoreMe
  status: 200
}

export type storeMePartialUpdateResponseSuccess = (storeMePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type storeMePartialUpdateResponse = (storeMePartialUpdateResponseSuccess)

export const getStoreMePartialUpdateUrl = () => {




  return `/api/v1/store/me`
}

/**
 * PATCH /me: update the logged-in user's own profile.
 */
export const storeMePartialUpdate = async (patchedProfileUpdateRequest?: PatchedProfileUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeMePartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeMePartialUpdateResponse>(getStoreMePartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProfileUpdateRequest)
  }
);}





export const getStoreMePartialUpdateMutationKey = () => ['storeMePartialUpdate'] as const;

export const getStoreMePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeMePartialUpdate>>, TError,StoreMePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeMePartialUpdate>>, TError,StoreMePartialUpdateMutationVariables, TContext> => {

const mutationKey = getStoreMePartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeMePartialUpdate>>, StoreMePartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeMePartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreMePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof storeMePartialUpdate>>>
    export type StoreMePartialUpdateMutationBody = PatchedProfileUpdateRequest | undefined
    export type StoreMePartialUpdateMutationError = unknown
    export type StoreMePartialUpdateMutationVariables = {data?: PatchedProfileUpdateRequest}

    export const useStoreMePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeMePartialUpdate>>, TError,StoreMePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeMePartialUpdate>>,
        TError,
        StoreMePartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreMePartialUpdateMutationOptions(options), queryClient);
    }
    export type storeModulesListResponse200 = {
  data: InstalledModule[]
  status: 200
}

export type storeModulesListResponseSuccess = (storeModulesListResponse200) & {
  headers: Headers;
};
;

export type storeModulesListResponse = (storeModulesListResponseSuccess)

export const getStoreModulesListUrl = () => {




  return `/api/v1/store/modules`
}

/**
 * Modules installed on this server. The frontends hide routes/menus of modules not listed here.
 */
export const storeModulesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeModulesListResponse> => {

  return apiFetch<storeModulesListResponse>(getStoreModulesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreModulesListQueryKey = () => {
    return [
    `/api/v1/store/modules`
    ] as const;
    }


export const getStoreModulesListQueryOptions = <TData = Awaited<ReturnType<typeof storeModulesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreModulesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeModulesList>>> = ({ signal }) => storeModulesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeModulesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreModulesListQueryResult = NonNullable<Awaited<ReturnType<typeof storeModulesList>>>
export type StoreModulesListQueryError = unknown


export function useStoreModulesList<TData = Awaited<ReturnType<typeof storeModulesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeModulesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeModulesList>>,
          TError,
          Awaited<ReturnType<typeof storeModulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreModulesList<TData = Awaited<ReturnType<typeof storeModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeModulesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeModulesList>>,
          TError,
          Awaited<ReturnType<typeof storeModulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreModulesList<TData = Awaited<ReturnType<typeof storeModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreModulesList<TData = Awaited<ReturnType<typeof storeModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreModulesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeNotificationsListResponse200 = {
  data: PaginatedNotificationList
  status: 200
}

export type storeNotificationsListResponseSuccess = (storeNotificationsListResponse200) & {
  headers: Headers;
};
;

export type storeNotificationsListResponse = (storeNotificationsListResponseSuccess)

export const getStoreNotificationsListUrl = (params?: StoreNotificationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/notifications?${stringifiedParams}` : `/api/v1/store/notifications`
}

/**
 * The logged-in user's notifications in this panel, newest first. `?unread=true` for unread only.
 */
export const storeNotificationsList = async (params?: StoreNotificationsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeNotificationsListResponse> => {

  return apiFetch<storeNotificationsListResponse>(getStoreNotificationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreNotificationsListQueryKey = (params?: StoreNotificationsListParams,) => {
    return [
    `/api/v1/store/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreNotificationsListQueryOptions = <TData = Awaited<ReturnType<typeof storeNotificationsList>>, TError = unknown>(params?: StoreNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreNotificationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeNotificationsList>>> = ({ signal }) => storeNotificationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreNotificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof storeNotificationsList>>>
export type StoreNotificationsListQueryError = unknown


export function useStoreNotificationsList<TData = Awaited<ReturnType<typeof storeNotificationsList>>, TError = unknown>(
 params: undefined |  StoreNotificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeNotificationsList>>,
          TError,
          Awaited<ReturnType<typeof storeNotificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreNotificationsList<TData = Awaited<ReturnType<typeof storeNotificationsList>>, TError = unknown>(
 params?: StoreNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeNotificationsList>>,
          TError,
          Awaited<ReturnType<typeof storeNotificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreNotificationsList<TData = Awaited<ReturnType<typeof storeNotificationsList>>, TError = unknown>(
 params?: StoreNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreNotificationsList<TData = Awaited<ReturnType<typeof storeNotificationsList>>, TError = unknown>(
 params?: StoreNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreNotificationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeNotificationsReadCreateResponse200 = {
  data: Notification
  status: 200
}

export type storeNotificationsReadCreateResponseSuccess = (storeNotificationsReadCreateResponse200) & {
  headers: Headers;
};
;

export type storeNotificationsReadCreateResponse = (storeNotificationsReadCreateResponseSuccess)

export const getStoreNotificationsReadCreateUrl = (uid: string,) => {




  return `/api/v1/store/notifications/${uid}/read`
}

export const storeNotificationsReadCreate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeNotificationsReadCreateResponse> => {

  return apiFetch<storeNotificationsReadCreateResponse>(getStoreNotificationsReadCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStoreNotificationsReadCreateMutationKey = () => ['storeNotificationsReadCreate'] as const;

export const getStoreNotificationsReadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeNotificationsReadCreate>>, TError,StoreNotificationsReadCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeNotificationsReadCreate>>, TError,StoreNotificationsReadCreateMutationVariables, TContext> => {

const mutationKey = getStoreNotificationsReadCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeNotificationsReadCreate>>, StoreNotificationsReadCreateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  storeNotificationsReadCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreNotificationsReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof storeNotificationsReadCreate>>>

    export type StoreNotificationsReadCreateMutationError = unknown
    export type StoreNotificationsReadCreateMutationVariables = {uid: string}

    export const useStoreNotificationsReadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeNotificationsReadCreate>>, TError,StoreNotificationsReadCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeNotificationsReadCreate>>,
        TError,
        StoreNotificationsReadCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreNotificationsReadCreateMutationOptions(options), queryClient);
    }
    export type storeNotificationsReadAllCreateResponse200 = {
  data: MarkedRead
  status: 200
}

export type storeNotificationsReadAllCreateResponseSuccess = (storeNotificationsReadAllCreateResponse200) & {
  headers: Headers;
};
;

export type storeNotificationsReadAllCreateResponse = (storeNotificationsReadAllCreateResponseSuccess)

export const getStoreNotificationsReadAllCreateUrl = () => {




  return `/api/v1/store/notifications/read-all`
}

export const storeNotificationsReadAllCreate = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeNotificationsReadAllCreateResponse> => {

  return apiFetch<storeNotificationsReadAllCreateResponse>(getStoreNotificationsReadAllCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStoreNotificationsReadAllCreateMutationKey = () => ['storeNotificationsReadAllCreate'] as const;

export const getStoreNotificationsReadAllCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeNotificationsReadAllCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeNotificationsReadAllCreate>>, TError,void, TContext> => {

const mutationKey = getStoreNotificationsReadAllCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeNotificationsReadAllCreate>>, void> = () => {


          return  storeNotificationsReadAllCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreNotificationsReadAllCreateMutationResult = NonNullable<Awaited<ReturnType<typeof storeNotificationsReadAllCreate>>>

    export type StoreNotificationsReadAllCreateMutationError = unknown


    export const useStoreNotificationsReadAllCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeNotificationsReadAllCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeNotificationsReadAllCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStoreNotificationsReadAllCreateMutationOptions(options), queryClient);
    }
    export type storeNotificationsUnreadCountRetrieveResponse200 = {
  data: UnreadCount
  status: 200
}

export type storeNotificationsUnreadCountRetrieveResponseSuccess = (storeNotificationsUnreadCountRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeNotificationsUnreadCountRetrieveResponse = (storeNotificationsUnreadCountRetrieveResponseSuccess)

export const getStoreNotificationsUnreadCountRetrieveUrl = () => {




  return `/api/v1/store/notifications/unread-count`
}

/**
 * Number for the red badge on the bell (the panels poll it).
 */
export const storeNotificationsUnreadCountRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeNotificationsUnreadCountRetrieveResponse> => {

  return apiFetch<storeNotificationsUnreadCountRetrieveResponse>(getStoreNotificationsUnreadCountRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreNotificationsUnreadCountRetrieveQueryKey = () => {
    return [
    `/api/v1/store/notifications/unread-count`
    ] as const;
    }


export const getStoreNotificationsUnreadCountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreNotificationsUnreadCountRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>> = ({ signal }) => storeNotificationsUnreadCountRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreNotificationsUnreadCountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>>
export type StoreNotificationsUnreadCountRetrieveQueryError = unknown


export function useStoreNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreNotificationsUnreadCountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeOrdersListResponse200 = {
  data: PaginatedCustomerOrderListList
  status: 200
}

export type storeOrdersListResponseSuccess = (storeOrdersListResponse200) & {
  headers: Headers;
};
;

export type storeOrdersListResponse = (storeOrdersListResponseSuccess)

export const getStoreOrdersListUrl = (params?: StoreOrdersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/orders?${stringifiedParams}` : `/api/v1/store/orders`
}

export const storeOrdersList = async (params?: StoreOrdersListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeOrdersListResponse> => {

  return apiFetch<storeOrdersListResponse>(getStoreOrdersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreOrdersListQueryKey = (params?: StoreOrdersListParams,) => {
    return [
    `/api/v1/store/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreOrdersListQueryOptions = <TData = Awaited<ReturnType<typeof storeOrdersList>>, TError = unknown>(params?: StoreOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreOrdersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeOrdersList>>> = ({ signal }) => storeOrdersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeOrdersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreOrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof storeOrdersList>>>
export type StoreOrdersListQueryError = unknown


export function useStoreOrdersList<TData = Awaited<ReturnType<typeof storeOrdersList>>, TError = unknown>(
 params: undefined |  StoreOrdersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeOrdersList>>,
          TError,
          Awaited<ReturnType<typeof storeOrdersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreOrdersList<TData = Awaited<ReturnType<typeof storeOrdersList>>, TError = unknown>(
 params?: StoreOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeOrdersList>>,
          TError,
          Awaited<ReturnType<typeof storeOrdersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreOrdersList<TData = Awaited<ReturnType<typeof storeOrdersList>>, TError = unknown>(
 params?: StoreOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreOrdersList<TData = Awaited<ReturnType<typeof storeOrdersList>>, TError = unknown>(
 params?: StoreOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreOrdersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeOrdersRetrieveResponse200 = {
  data: CustomerOrder
  status: 200
}

export type storeOrdersRetrieveResponseSuccess = (storeOrdersRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeOrdersRetrieveResponse = (storeOrdersRetrieveResponseSuccess)

export const getStoreOrdersRetrieveUrl = (number: string,) => {




  return `/api/v1/store/orders/${number}`
}

export const storeOrdersRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeOrdersRetrieveResponse> => {

  return apiFetch<storeOrdersRetrieveResponse>(getStoreOrdersRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreOrdersRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/store/orders/${number}`
    ] as const;
    }


export const getStoreOrdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreOrdersRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeOrdersRetrieve>>> = ({ signal }) => storeOrdersRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreOrdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeOrdersRetrieve>>>
export type StoreOrdersRetrieveQueryError = unknown


export function useStoreOrdersRetrieve<TData = Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreOrdersRetrieve<TData = Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreOrdersRetrieve<TData = Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreOrdersRetrieve<TData = Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreOrdersRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeOrdersAbandonResponse200 = {
  data: CustomerOrder
  status: 200
}

export type storeOrdersAbandonResponseSuccess = (storeOrdersAbandonResponse200) & {
  headers: Headers;
};
;

export type storeOrdersAbandonResponse = (storeOrdersAbandonResponseSuccess)

export const getStoreOrdersAbandonUrl = (number: string,) => {




  return `/api/v1/store/orders/${number}/abandon`
}

/**
 * Give up an unpaid order to pay another way: its stock and coupon are released at once.
 */
export const storeOrdersAbandon = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeOrdersAbandonResponse> => {

  return apiFetch<storeOrdersAbandonResponse>(getStoreOrdersAbandonUrl(number),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStoreOrdersAbandonMutationKey = () => ['storeOrdersAbandon'] as const;

export const getStoreOrdersAbandonMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeOrdersAbandon>>, TError,StoreOrdersAbandonMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeOrdersAbandon>>, TError,StoreOrdersAbandonMutationVariables, TContext> => {

const mutationKey = getStoreOrdersAbandonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeOrdersAbandon>>, StoreOrdersAbandonMutationVariables> = (props) => {
          const {number} = props ?? {};

          return  storeOrdersAbandon(number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreOrdersAbandonMutationResult = NonNullable<Awaited<ReturnType<typeof storeOrdersAbandon>>>

    export type StoreOrdersAbandonMutationError = unknown
    export type StoreOrdersAbandonMutationVariables = {number: string}

    export const useStoreOrdersAbandon = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeOrdersAbandon>>, TError,StoreOrdersAbandonMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeOrdersAbandon>>,
        TError,
        StoreOrdersAbandonMutationVariables,
        TContext
      > => {
      return useMutation(getStoreOrdersAbandonMutationOptions(options), queryClient);
    }
    export type storeOrdersCancelResponse200 = {
  data: CustomerOrder
  status: 200
}

export type storeOrdersCancelResponseSuccess = (storeOrdersCancelResponse200) & {
  headers: Headers;
};
;

export type storeOrdersCancelResponse = (storeOrdersCancelResponseSuccess)

export const getStoreOrdersCancelUrl = (number: string,) => {




  return `/api/v1/store/orders/${number}/cancel`
}

/**
 * Cancel the order (every part that may still be cancelled), or one store's part of it.
 */
export const storeOrdersCancel = async (number: string,
    customerCancelRequest: CustomerCancelRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeOrdersCancelResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeOrdersCancelResponse>(getStoreOrdersCancelUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(customerCancelRequest)
  }
);}





export const getStoreOrdersCancelMutationKey = () => ['storeOrdersCancel'] as const;

export const getStoreOrdersCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeOrdersCancel>>, TError,StoreOrdersCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeOrdersCancel>>, TError,StoreOrdersCancelMutationVariables, TContext> => {

const mutationKey = getStoreOrdersCancelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeOrdersCancel>>, StoreOrdersCancelMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  storeOrdersCancel(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreOrdersCancelMutationResult = NonNullable<Awaited<ReturnType<typeof storeOrdersCancel>>>
    export type StoreOrdersCancelMutationBody = CustomerCancelRequest
    export type StoreOrdersCancelMutationError = unknown
    export type StoreOrdersCancelMutationVariables = {number: string;data: CustomerCancelRequest}

    export const useStoreOrdersCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeOrdersCancel>>, TError,StoreOrdersCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeOrdersCancel>>,
        TError,
        StoreOrdersCancelMutationVariables,
        TContext
      > => {
      return useMutation(getStoreOrdersCancelMutationOptions(options), queryClient);
    }
    export type storeOrderInvoicesResponse200 = {
  data: Invoice[]
  status: 200
}

export type storeOrderInvoicesResponseSuccess = (storeOrderInvoicesResponse200) & {
  headers: Headers;
};
;

export type storeOrderInvoicesResponse = (storeOrderInvoicesResponseSuccess)

export const getStoreOrderInvoicesUrl = (number: string,) => {




  return `/api/v1/store/orders/${number}/invoices`
}

export const storeOrderInvoices = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeOrderInvoicesResponse> => {

  return apiFetch<storeOrderInvoicesResponse>(getStoreOrderInvoicesUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreOrderInvoicesQueryKey = (number: string,) => {
    return [
    `/api/v1/store/orders/${number}/invoices`
    ] as const;
    }


export const getStoreOrderInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof storeOrderInvoices>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrderInvoices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreOrderInvoicesQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeOrderInvoices>>> = ({ signal }) => storeOrderInvoices(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeOrderInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreOrderInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof storeOrderInvoices>>>
export type StoreOrderInvoicesQueryError = unknown


export function useStoreOrderInvoices<TData = Awaited<ReturnType<typeof storeOrderInvoices>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrderInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeOrderInvoices>>,
          TError,
          Awaited<ReturnType<typeof storeOrderInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreOrderInvoices<TData = Awaited<ReturnType<typeof storeOrderInvoices>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrderInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeOrderInvoices>>,
          TError,
          Awaited<ReturnType<typeof storeOrderInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreOrderInvoices<TData = Awaited<ReturnType<typeof storeOrderInvoices>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrderInvoices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreOrderInvoices<TData = Awaited<ReturnType<typeof storeOrderInvoices>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeOrderInvoices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreOrderInvoicesQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeOrdersPayResponse200 = {
  data: PaymentOptions
  status: 200
}

export type storeOrdersPayResponseSuccess = (storeOrdersPayResponse200) & {
  headers: Headers;
};
;

export type storeOrdersPayResponse = (storeOrdersPayResponseSuccess)

export const getStoreOrdersPayUrl = (number: string,) => {




  return `/api/v1/store/orders/${number}/pay`
}

export const storeOrdersPay = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeOrdersPayResponse> => {

  return apiFetch<storeOrdersPayResponse>(getStoreOrdersPayUrl(number),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStoreOrdersPayMutationKey = () => ['storeOrdersPay'] as const;

export const getStoreOrdersPayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeOrdersPay>>, TError,StoreOrdersPayMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeOrdersPay>>, TError,StoreOrdersPayMutationVariables, TContext> => {

const mutationKey = getStoreOrdersPayMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeOrdersPay>>, StoreOrdersPayMutationVariables> = (props) => {
          const {number} = props ?? {};

          return  storeOrdersPay(number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreOrdersPayMutationResult = NonNullable<Awaited<ReturnType<typeof storeOrdersPay>>>

    export type StoreOrdersPayMutationError = unknown
    export type StoreOrdersPayMutationVariables = {number: string}

    export const useStoreOrdersPay = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeOrdersPay>>, TError,StoreOrdersPayMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeOrdersPay>>,
        TError,
        StoreOrdersPayMutationVariables,
        TContext
      > => {
      return useMutation(getStoreOrdersPayMutationOptions(options), queryClient);
    }
    export type storePaymentsConfirmResponse200 = {
  data: PaymentResult
  status: 200
}

export type storePaymentsConfirmResponseSuccess = (storePaymentsConfirmResponse200) & {
  headers: Headers;
};
;

export type storePaymentsConfirmResponse = (storePaymentsConfirmResponseSuccess)

export const getStorePaymentsConfirmUrl = () => {




  return `/api/v1/store/payments/confirm`
}

/**
 * The storefront posts what the gateway's widget returned. Nothing is trusted until verified.
 */
export const storePaymentsConfirm = async (paymentConfirmRequest: PaymentConfirmRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storePaymentsConfirmResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storePaymentsConfirmResponse>(getStorePaymentsConfirmUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentConfirmRequest)
  }
);}





export const getStorePaymentsConfirmMutationKey = () => ['storePaymentsConfirm'] as const;

export const getStorePaymentsConfirmMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storePaymentsConfirm>>, TError,StorePaymentsConfirmMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storePaymentsConfirm>>, TError,StorePaymentsConfirmMutationVariables, TContext> => {

const mutationKey = getStorePaymentsConfirmMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storePaymentsConfirm>>, StorePaymentsConfirmMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storePaymentsConfirm(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StorePaymentsConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof storePaymentsConfirm>>>
    export type StorePaymentsConfirmMutationBody = PaymentConfirmRequest
    export type StorePaymentsConfirmMutationError = unknown
    export type StorePaymentsConfirmMutationVariables = {data: PaymentConfirmRequest}

    export const useStorePaymentsConfirm = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storePaymentsConfirm>>, TError,StorePaymentsConfirmMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storePaymentsConfirm>>,
        TError,
        StorePaymentsConfirmMutationVariables,
        TContext
      > => {
      return useMutation(getStorePaymentsConfirmMutationOptions(options), queryClient);
    }
    export type storePaymentsFakePayResponse200 = {
  data: FakePaymentResult
  status: 200
}

export type storePaymentsFakePayResponseSuccess = (storePaymentsFakePayResponse200) & {
  headers: Headers;
};
;

export type storePaymentsFakePayResponse = (storePaymentsFakePayResponseSuccess)

export const getStorePaymentsFakePayUrl = () => {




  return `/api/v1/store/payments/fake-pay`
}

/**
 * Development only: the fake gateway's checkout widget (404 with a real gateway).
 */
export const storePaymentsFakePay = async (fakePaymentRequest: FakePaymentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storePaymentsFakePayResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storePaymentsFakePayResponse>(getStorePaymentsFakePayUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(fakePaymentRequest)
  }
);}





export const getStorePaymentsFakePayMutationKey = () => ['storePaymentsFakePay'] as const;

export const getStorePaymentsFakePayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storePaymentsFakePay>>, TError,StorePaymentsFakePayMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storePaymentsFakePay>>, TError,StorePaymentsFakePayMutationVariables, TContext> => {

const mutationKey = getStorePaymentsFakePayMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storePaymentsFakePay>>, StorePaymentsFakePayMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storePaymentsFakePay(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StorePaymentsFakePayMutationResult = NonNullable<Awaited<ReturnType<typeof storePaymentsFakePay>>>
    export type StorePaymentsFakePayMutationBody = FakePaymentRequest
    export type StorePaymentsFakePayMutationError = unknown
    export type StorePaymentsFakePayMutationVariables = {data: FakePaymentRequest}

    export const useStorePaymentsFakePay = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storePaymentsFakePay>>, TError,StorePaymentsFakePayMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storePaymentsFakePay>>,
        TError,
        StorePaymentsFakePayMutationVariables,
        TContext
      > => {
      return useMutation(getStorePaymentsFakePayMutationOptions(options), queryClient);
    }
    export type storeProductsListResponse200 = {
  data: StoreListing
  status: 200
}

export type storeProductsListResponseSuccess = (storeProductsListResponse200) & {
  headers: Headers;
};
;

export type storeProductsListResponse = (storeProductsListResponseSuccess)

export const getStoreProductsListUrl = (params?: StoreProductsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/products?${stringifiedParams}` : `/api/v1/store/products`
}

/**
 * Category, search and vehicle pages: one page of product cards plus filter facets with counts.
 * Any filterable attribute of the category: `attr_<code>=a,b` (options), `=true` (yes/no), `=10-50` (numbers).
 */
export const storeProductsList = async (params?: StoreProductsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeProductsListResponse> => {

  return apiFetch<storeProductsListResponse>(getStoreProductsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreProductsListQueryKey = (params?: StoreProductsListParams,) => {
    return [
    `/api/v1/store/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreProductsListQueryOptions = <TData = Awaited<ReturnType<typeof storeProductsList>>, TError = unknown>(params?: StoreProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreProductsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeProductsList>>> = ({ signal }) => storeProductsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeProductsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof storeProductsList>>>
export type StoreProductsListQueryError = unknown


export function useStoreProductsList<TData = Awaited<ReturnType<typeof storeProductsList>>, TError = unknown>(
 params: undefined |  StoreProductsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeProductsList>>,
          TError,
          Awaited<ReturnType<typeof storeProductsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreProductsList<TData = Awaited<ReturnType<typeof storeProductsList>>, TError = unknown>(
 params?: StoreProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeProductsList>>,
          TError,
          Awaited<ReturnType<typeof storeProductsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreProductsList<TData = Awaited<ReturnType<typeof storeProductsList>>, TError = unknown>(
 params?: StoreProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreProductsList<TData = Awaited<ReturnType<typeof storeProductsList>>, TError = unknown>(
 params?: StoreProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreProductsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeProductsRetrieveResponse200 = {
  data: StoreProductPage
  status: 200
}

export type storeProductsRetrieveResponseSuccess = (storeProductsRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeProductsRetrieveResponse = (storeProductsRetrieveResponseSuccess)

export const getStoreProductsRetrieveUrl = (slug: string,
    params?: StoreProductsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/products/${slug}?${stringifiedParams}` : `/api/v1/store/products/${slug}`
}

export const storeProductsRetrieve = async (slug: string,
    params?: StoreProductsRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeProductsRetrieveResponse> => {

  return apiFetch<storeProductsRetrieveResponse>(getStoreProductsRetrieveUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreProductsRetrieveQueryKey = (slug: string,
    params?: StoreProductsRetrieveParams,) => {
    return [
    `/api/v1/store/products/${slug}`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreProductsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeProductsRetrieve>>, TError = unknown>(slug: string,
    params?: StoreProductsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreProductsRetrieveQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeProductsRetrieve>>> = ({ signal }) => storeProductsRetrieve(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeProductsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreProductsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeProductsRetrieve>>>
export type StoreProductsRetrieveQueryError = unknown


export function useStoreProductsRetrieve<TData = Awaited<ReturnType<typeof storeProductsRetrieve>>, TError = unknown>(
 slug: string,
    params: undefined |  StoreProductsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeProductsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeProductsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreProductsRetrieve<TData = Awaited<ReturnType<typeof storeProductsRetrieve>>, TError = unknown>(
 slug: string,
    params?: StoreProductsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeProductsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeProductsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreProductsRetrieve<TData = Awaited<ReturnType<typeof storeProductsRetrieve>>, TError = unknown>(
 slug: string,
    params?: StoreProductsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreProductsRetrieve<TData = Awaited<ReturnType<typeof storeProductsRetrieve>>, TError = unknown>(
 slug: string,
    params?: StoreProductsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreProductsRetrieveQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeProductReviewsResponse200 = {
  data: ProductReviews
  status: 200
}

export type storeProductReviewsResponseSuccess = (storeProductReviewsResponse200) & {
  headers: Headers;
};
;

export type storeProductReviewsResponse = (storeProductReviewsResponseSuccess)

export const getStoreProductReviewsUrl = (slug: string,
    params?: StoreProductReviewsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/products/${slug}/reviews?${stringifiedParams}` : `/api/v1/store/products/${slug}/reviews`
}

export const storeProductReviews = async (slug: string,
    params?: StoreProductReviewsParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeProductReviewsResponse> => {

  return apiFetch<storeProductReviewsResponse>(getStoreProductReviewsUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreProductReviewsQueryKey = (slug: string,
    params?: StoreProductReviewsParams,) => {
    return [
    `/api/v1/store/products/${slug}/reviews`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreProductReviewsQueryOptions = <TData = Awaited<ReturnType<typeof storeProductReviews>>, TError = unknown>(slug: string,
    params?: StoreProductReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductReviews>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreProductReviewsQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeProductReviews>>> = ({ signal }) => storeProductReviews(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeProductReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreProductReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof storeProductReviews>>>
export type StoreProductReviewsQueryError = unknown


export function useStoreProductReviews<TData = Awaited<ReturnType<typeof storeProductReviews>>, TError = unknown>(
 slug: string,
    params: undefined |  StoreProductReviewsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductReviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeProductReviews>>,
          TError,
          Awaited<ReturnType<typeof storeProductReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreProductReviews<TData = Awaited<ReturnType<typeof storeProductReviews>>, TError = unknown>(
 slug: string,
    params?: StoreProductReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductReviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeProductReviews>>,
          TError,
          Awaited<ReturnType<typeof storeProductReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreProductReviews<TData = Awaited<ReturnType<typeof storeProductReviews>>, TError = unknown>(
 slug: string,
    params?: StoreProductReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductReviews>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreProductReviews<TData = Awaited<ReturnType<typeof storeProductReviews>>, TError = unknown>(
 slug: string,
    params?: StoreProductReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductReviews>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreProductReviewsQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeProductsSimilarResponse200 = {
  data: StoreProductCard[]
  status: 200
}

export type storeProductsSimilarResponseSuccess = (storeProductsSimilarResponse200) & {
  headers: Headers;
};
;

export type storeProductsSimilarResponse = (storeProductsSimilarResponseSuccess)

export const getStoreProductsSimilarUrl = (slug: string,
    params?: StoreProductsSimilarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/products/${slug}/similar?${stringifiedParams}` : `/api/v1/store/products/${slug}/similar`
}

export const storeProductsSimilar = async (slug: string,
    params?: StoreProductsSimilarParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeProductsSimilarResponse> => {

  return apiFetch<storeProductsSimilarResponse>(getStoreProductsSimilarUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreProductsSimilarQueryKey = (slug: string,
    params?: StoreProductsSimilarParams,) => {
    return [
    `/api/v1/store/products/${slug}/similar`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreProductsSimilarQueryOptions = <TData = Awaited<ReturnType<typeof storeProductsSimilar>>, TError = unknown>(slug: string,
    params?: StoreProductsSimilarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsSimilar>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreProductsSimilarQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeProductsSimilar>>> = ({ signal }) => storeProductsSimilar(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeProductsSimilar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreProductsSimilarQueryResult = NonNullable<Awaited<ReturnType<typeof storeProductsSimilar>>>
export type StoreProductsSimilarQueryError = unknown


export function useStoreProductsSimilar<TData = Awaited<ReturnType<typeof storeProductsSimilar>>, TError = unknown>(
 slug: string,
    params: undefined |  StoreProductsSimilarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsSimilar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeProductsSimilar>>,
          TError,
          Awaited<ReturnType<typeof storeProductsSimilar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreProductsSimilar<TData = Awaited<ReturnType<typeof storeProductsSimilar>>, TError = unknown>(
 slug: string,
    params?: StoreProductsSimilarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsSimilar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeProductsSimilar>>,
          TError,
          Awaited<ReturnType<typeof storeProductsSimilar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreProductsSimilar<TData = Awaited<ReturnType<typeof storeProductsSimilar>>, TError = unknown>(
 slug: string,
    params?: StoreProductsSimilarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsSimilar>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreProductsSimilar<TData = Awaited<ReturnType<typeof storeProductsSimilar>>, TError = unknown>(
 slug: string,
    params?: StoreProductsSimilarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeProductsSimilar>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreProductsSimilarQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeReturnsListResponse200 = {
  data: PaginatedReturnListList
  status: 200
}

export type storeReturnsListResponseSuccess = (storeReturnsListResponse200) & {
  headers: Headers;
};
;

export type storeReturnsListResponse = (storeReturnsListResponseSuccess)

export const getStoreReturnsListUrl = (params?: StoreReturnsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/returns?${stringifiedParams}` : `/api/v1/store/returns`
}

export const storeReturnsList = async (params?: StoreReturnsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeReturnsListResponse> => {

  return apiFetch<storeReturnsListResponse>(getStoreReturnsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreReturnsListQueryKey = (params?: StoreReturnsListParams,) => {
    return [
    `/api/v1/store/returns`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreReturnsListQueryOptions = <TData = Awaited<ReturnType<typeof storeReturnsList>>, TError = unknown>(params?: StoreReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreReturnsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeReturnsList>>> = ({ signal }) => storeReturnsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeReturnsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreReturnsListQueryResult = NonNullable<Awaited<ReturnType<typeof storeReturnsList>>>
export type StoreReturnsListQueryError = unknown


export function useStoreReturnsList<TData = Awaited<ReturnType<typeof storeReturnsList>>, TError = unknown>(
 params: undefined |  StoreReturnsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReturnsList>>,
          TError,
          Awaited<ReturnType<typeof storeReturnsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReturnsList<TData = Awaited<ReturnType<typeof storeReturnsList>>, TError = unknown>(
 params?: StoreReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReturnsList>>,
          TError,
          Awaited<ReturnType<typeof storeReturnsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReturnsList<TData = Awaited<ReturnType<typeof storeReturnsList>>, TError = unknown>(
 params?: StoreReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreReturnsList<TData = Awaited<ReturnType<typeof storeReturnsList>>, TError = unknown>(
 params?: StoreReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreReturnsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeReturnsCreateResponse201 = {
  data: ReturnDetail
  status: 201
}

export type storeReturnsCreateResponseSuccess = (storeReturnsCreateResponse201) & {
  headers: Headers;
};
;

export type storeReturnsCreateResponse = (storeReturnsCreateResponseSuccess)

export const getStoreReturnsCreateUrl = () => {




  return `/api/v1/store/returns`
}

export const storeReturnsCreate = async (createReturnRequest: CreateReturnRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeReturnsCreateResponse> => {
    const formData = new FormData();
formData.append(`order`, createReturnRequest.order);
formData.append(`item`, createReturnRequest.item);
formData.append(`type`, createReturnRequest.type);
formData.append(`quantity`, createReturnRequest.quantity.toString())
formData.append(`reason`, createReturnRequest.reason);
if(createReturnRequest.photos !== undefined) {
 createReturnRequest.photos.forEach(value => formData.append(`photos`, value));
 }

  return apiFetch<storeReturnsCreateResponse>(getStoreReturnsCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getStoreReturnsCreateMutationKey = () => ['storeReturnsCreate'] as const;

export const getStoreReturnsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeReturnsCreate>>, TError,StoreReturnsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeReturnsCreate>>, TError,StoreReturnsCreateMutationVariables, TContext> => {

const mutationKey = getStoreReturnsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeReturnsCreate>>, StoreReturnsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeReturnsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreReturnsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof storeReturnsCreate>>>
    export type StoreReturnsCreateMutationBody = CreateReturnRequest
    export type StoreReturnsCreateMutationError = unknown
    export type StoreReturnsCreateMutationVariables = {data: CreateReturnRequest}

    export const useStoreReturnsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeReturnsCreate>>, TError,StoreReturnsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeReturnsCreate>>,
        TError,
        StoreReturnsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreReturnsCreateMutationOptions(options), queryClient);
    }
    export type storeReturnsRetrieveResponse200 = {
  data: ReturnDetail
  status: 200
}

export type storeReturnsRetrieveResponseSuccess = (storeReturnsRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeReturnsRetrieveResponse = (storeReturnsRetrieveResponseSuccess)

export const getStoreReturnsRetrieveUrl = (number: string,) => {




  return `/api/v1/store/returns/${number}`
}

export const storeReturnsRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeReturnsRetrieveResponse> => {

  return apiFetch<storeReturnsRetrieveResponse>(getStoreReturnsRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreReturnsRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/store/returns/${number}`
    ] as const;
    }


export const getStoreReturnsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreReturnsRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeReturnsRetrieve>>> = ({ signal }) => storeReturnsRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreReturnsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeReturnsRetrieve>>>
export type StoreReturnsRetrieveQueryError = unknown


export function useStoreReturnsRetrieve<TData = Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReturnsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeReturnsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReturnsRetrieve<TData = Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReturnsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeReturnsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReturnsRetrieve<TData = Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreReturnsRetrieve<TData = Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreReturnsRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeReturnsPhotoResponse200 = {
  data: Blob
  status: 200
}

export type storeReturnsPhotoResponseSuccess = (storeReturnsPhotoResponse200) & {
  headers: Headers;
};
;

export type storeReturnsPhotoResponse = (storeReturnsPhotoResponseSuccess)

export const getStoreReturnsPhotoUrl = (number: string,
    mediaUid: string,) => {




  return `/api/v1/store/returns/${number}/photos/${mediaUid}`
}

export const storeReturnsPhoto = async (number: string,
    mediaUid: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeReturnsPhotoResponse> => {

  return apiFetch<storeReturnsPhotoResponse>(getStoreReturnsPhotoUrl(number,mediaUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreReturnsPhotoQueryKey = (number: string,
    mediaUid: string,) => {
    return [
    `/api/v1/store/returns/${number}/photos/${mediaUid}`
    ] as const;
    }


export const getStoreReturnsPhotoQueryOptions = <TData = Awaited<ReturnType<typeof storeReturnsPhoto>>, TError = unknown>(number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreReturnsPhotoQueryKey(number,mediaUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeReturnsPhoto>>> = ({ signal }) => storeReturnsPhoto(number,mediaUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined && mediaUid !== null && mediaUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeReturnsPhoto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreReturnsPhotoQueryResult = NonNullable<Awaited<ReturnType<typeof storeReturnsPhoto>>>
export type StoreReturnsPhotoQueryError = unknown


export function useStoreReturnsPhoto<TData = Awaited<ReturnType<typeof storeReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsPhoto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReturnsPhoto>>,
          TError,
          Awaited<ReturnType<typeof storeReturnsPhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReturnsPhoto<TData = Awaited<ReturnType<typeof storeReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsPhoto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReturnsPhoto>>,
          TError,
          Awaited<ReturnType<typeof storeReturnsPhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReturnsPhoto<TData = Awaited<ReturnType<typeof storeReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreReturnsPhoto<TData = Awaited<ReturnType<typeof storeReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreReturnsPhotoQueryOptions(number,mediaUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeReturnsWithdrawResponse200 = {
  data: ReturnDetail
  status: 200
}

export type storeReturnsWithdrawResponseSuccess = (storeReturnsWithdrawResponse200) & {
  headers: Headers;
};
;

export type storeReturnsWithdrawResponse = (storeReturnsWithdrawResponseSuccess)

export const getStoreReturnsWithdrawUrl = (number: string,) => {




  return `/api/v1/store/returns/${number}/withdraw`
}

export const storeReturnsWithdraw = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeReturnsWithdrawResponse> => {

  return apiFetch<storeReturnsWithdrawResponse>(getStoreReturnsWithdrawUrl(number),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStoreReturnsWithdrawMutationKey = () => ['storeReturnsWithdraw'] as const;

export const getStoreReturnsWithdrawMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeReturnsWithdraw>>, TError,StoreReturnsWithdrawMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeReturnsWithdraw>>, TError,StoreReturnsWithdrawMutationVariables, TContext> => {

const mutationKey = getStoreReturnsWithdrawMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeReturnsWithdraw>>, StoreReturnsWithdrawMutationVariables> = (props) => {
          const {number} = props ?? {};

          return  storeReturnsWithdraw(number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreReturnsWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof storeReturnsWithdraw>>>

    export type StoreReturnsWithdrawMutationError = unknown
    export type StoreReturnsWithdrawMutationVariables = {number: string}

    export const useStoreReturnsWithdraw = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeReturnsWithdraw>>, TError,StoreReturnsWithdrawMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeReturnsWithdraw>>,
        TError,
        StoreReturnsWithdrawMutationVariables,
        TContext
      > => {
      return useMutation(getStoreReturnsWithdrawMutationOptions(options), queryClient);
    }
    export type storeReturnsEligibilityResponse200 = {
  data: Eligibility
  status: 200
}

export type storeReturnsEligibilityResponseSuccess = (storeReturnsEligibilityResponse200) & {
  headers: Headers;
};
;

export type storeReturnsEligibilityResponse = (storeReturnsEligibilityResponseSuccess)

export const getStoreReturnsEligibilityUrl = (params: StoreReturnsEligibilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/returns/eligibility?${stringifiedParams}` : `/api/v1/store/returns/eligibility`
}

export const storeReturnsEligibility = async (params: StoreReturnsEligibilityParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeReturnsEligibilityResponse> => {

  return apiFetch<storeReturnsEligibilityResponse>(getStoreReturnsEligibilityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreReturnsEligibilityQueryKey = (params?: StoreReturnsEligibilityParams,) => {
    return [
    `/api/v1/store/returns/eligibility`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreReturnsEligibilityQueryOptions = <TData = Awaited<ReturnType<typeof storeReturnsEligibility>>, TError = unknown>(params: StoreReturnsEligibilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsEligibility>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreReturnsEligibilityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeReturnsEligibility>>> = ({ signal }) => storeReturnsEligibility(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeReturnsEligibility>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreReturnsEligibilityQueryResult = NonNullable<Awaited<ReturnType<typeof storeReturnsEligibility>>>
export type StoreReturnsEligibilityQueryError = unknown


export function useStoreReturnsEligibility<TData = Awaited<ReturnType<typeof storeReturnsEligibility>>, TError = unknown>(
 params: StoreReturnsEligibilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsEligibility>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReturnsEligibility>>,
          TError,
          Awaited<ReturnType<typeof storeReturnsEligibility>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReturnsEligibility<TData = Awaited<ReturnType<typeof storeReturnsEligibility>>, TError = unknown>(
 params: StoreReturnsEligibilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsEligibility>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReturnsEligibility>>,
          TError,
          Awaited<ReturnType<typeof storeReturnsEligibility>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReturnsEligibility<TData = Awaited<ReturnType<typeof storeReturnsEligibility>>, TError = unknown>(
 params: StoreReturnsEligibilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsEligibility>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreReturnsEligibility<TData = Awaited<ReturnType<typeof storeReturnsEligibility>>, TError = unknown>(
 params: StoreReturnsEligibilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReturnsEligibility>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreReturnsEligibilityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeReviewsMineResponse200 = {
  data: PaginatedMyReviewList
  status: 200
}

export type storeReviewsMineResponseSuccess = (storeReviewsMineResponse200) & {
  headers: Headers;
};
;

export type storeReviewsMineResponse = (storeReviewsMineResponseSuccess)

export const getStoreReviewsMineUrl = (params?: StoreReviewsMineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/reviews?${stringifiedParams}` : `/api/v1/store/reviews`
}

export const storeReviewsMine = async (params?: StoreReviewsMineParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeReviewsMineResponse> => {

  return apiFetch<storeReviewsMineResponse>(getStoreReviewsMineUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreReviewsMineQueryKey = (params?: StoreReviewsMineParams,) => {
    return [
    `/api/v1/store/reviews`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreReviewsMineQueryOptions = <TData = Awaited<ReturnType<typeof storeReviewsMine>>, TError = unknown>(params?: StoreReviewsMineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsMine>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreReviewsMineQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeReviewsMine>>> = ({ signal }) => storeReviewsMine(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeReviewsMine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreReviewsMineQueryResult = NonNullable<Awaited<ReturnType<typeof storeReviewsMine>>>
export type StoreReviewsMineQueryError = unknown


export function useStoreReviewsMine<TData = Awaited<ReturnType<typeof storeReviewsMine>>, TError = unknown>(
 params: undefined |  StoreReviewsMineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsMine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReviewsMine>>,
          TError,
          Awaited<ReturnType<typeof storeReviewsMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReviewsMine<TData = Awaited<ReturnType<typeof storeReviewsMine>>, TError = unknown>(
 params?: StoreReviewsMineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsMine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReviewsMine>>,
          TError,
          Awaited<ReturnType<typeof storeReviewsMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReviewsMine<TData = Awaited<ReturnType<typeof storeReviewsMine>>, TError = unknown>(
 params?: StoreReviewsMineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsMine>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreReviewsMine<TData = Awaited<ReturnType<typeof storeReviewsMine>>, TError = unknown>(
 params?: StoreReviewsMineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsMine>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreReviewsMineQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeReviewsCreateResponse201 = {
  data: MyReview
  status: 201
}

export type storeReviewsCreateResponseSuccess = (storeReviewsCreateResponse201) & {
  headers: Headers;
};
;

export type storeReviewsCreateResponse = (storeReviewsCreateResponseSuccess)

export const getStoreReviewsCreateUrl = () => {




  return `/api/v1/store/reviews`
}

/**
 * Rate and review a delivered item (one review per item).
 */
export const storeReviewsCreate = async (createRequest: CreateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeReviewsCreateResponse> => {
    const formData = new FormData();
formData.append(`item`, createRequest.item);
formData.append(`rating`, createRequest.rating.toString())
if(createRequest.title !== undefined) {
 formData.append(`title`, createRequest.title);
 }
if(createRequest.body !== undefined) {
 formData.append(`body`, createRequest.body);
 }
if(createRequest.photos !== undefined) {
 createRequest.photos.forEach(value => formData.append(`photos`, value));
 }

  return apiFetch<storeReviewsCreateResponse>(getStoreReviewsCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getStoreReviewsCreateMutationKey = () => ['storeReviewsCreate'] as const;

export const getStoreReviewsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeReviewsCreate>>, TError,StoreReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeReviewsCreate>>, TError,StoreReviewsCreateMutationVariables, TContext> => {

const mutationKey = getStoreReviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeReviewsCreate>>, StoreReviewsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeReviewsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreReviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof storeReviewsCreate>>>
    export type StoreReviewsCreateMutationBody = CreateRequest
    export type StoreReviewsCreateMutationError = unknown
    export type StoreReviewsCreateMutationVariables = {data: CreateRequest}

    export const useStoreReviewsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeReviewsCreate>>, TError,StoreReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeReviewsCreate>>,
        TError,
        StoreReviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreReviewsCreateMutationOptions(options), queryClient);
    }
    export type storeReviewsEligibleResponse200 = {
  data: Eligible[]
  status: 200
}

export type storeReviewsEligibleResponseSuccess = (storeReviewsEligibleResponse200) & {
  headers: Headers;
};
;

export type storeReviewsEligibleResponse = (storeReviewsEligibleResponseSuccess)

export const getStoreReviewsEligibleUrl = () => {




  return `/api/v1/store/reviews/eligible`
}

export const storeReviewsEligible = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeReviewsEligibleResponse> => {

  return apiFetch<storeReviewsEligibleResponse>(getStoreReviewsEligibleUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreReviewsEligibleQueryKey = () => {
    return [
    `/api/v1/store/reviews/eligible`
    ] as const;
    }


export const getStoreReviewsEligibleQueryOptions = <TData = Awaited<ReturnType<typeof storeReviewsEligible>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsEligible>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreReviewsEligibleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeReviewsEligible>>> = ({ signal }) => storeReviewsEligible({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeReviewsEligible>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreReviewsEligibleQueryResult = NonNullable<Awaited<ReturnType<typeof storeReviewsEligible>>>
export type StoreReviewsEligibleQueryError = unknown


export function useStoreReviewsEligible<TData = Awaited<ReturnType<typeof storeReviewsEligible>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsEligible>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReviewsEligible>>,
          TError,
          Awaited<ReturnType<typeof storeReviewsEligible>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReviewsEligible<TData = Awaited<ReturnType<typeof storeReviewsEligible>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsEligible>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeReviewsEligible>>,
          TError,
          Awaited<ReturnType<typeof storeReviewsEligible>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreReviewsEligible<TData = Awaited<ReturnType<typeof storeReviewsEligible>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsEligible>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreReviewsEligible<TData = Awaited<ReturnType<typeof storeReviewsEligible>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeReviewsEligible>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreReviewsEligibleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeSearchSuggestResponse200 = {
  data: StoreSuggestions
  status: 200
}

export type storeSearchSuggestResponseSuccess = (storeSearchSuggestResponse200) & {
  headers: Headers;
};
;

export type storeSearchSuggestResponse = (storeSearchSuggestResponseSuccess)

export const getStoreSearchSuggestUrl = (params: StoreSearchSuggestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/search/suggest?${stringifiedParams}` : `/api/v1/store/search/suggest`
}

export const storeSearchSuggest = async (params: StoreSearchSuggestParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeSearchSuggestResponse> => {

  return apiFetch<storeSearchSuggestResponse>(getStoreSearchSuggestUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreSearchSuggestQueryKey = (params?: StoreSearchSuggestParams,) => {
    return [
    `/api/v1/store/search/suggest`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreSearchSuggestQueryOptions = <TData = Awaited<ReturnType<typeof storeSearchSuggest>>, TError = unknown>(params: StoreSearchSuggestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSearchSuggest>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreSearchSuggestQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeSearchSuggest>>> = ({ signal }) => storeSearchSuggest(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeSearchSuggest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreSearchSuggestQueryResult = NonNullable<Awaited<ReturnType<typeof storeSearchSuggest>>>
export type StoreSearchSuggestQueryError = unknown


export function useStoreSearchSuggest<TData = Awaited<ReturnType<typeof storeSearchSuggest>>, TError = unknown>(
 params: StoreSearchSuggestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSearchSuggest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeSearchSuggest>>,
          TError,
          Awaited<ReturnType<typeof storeSearchSuggest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreSearchSuggest<TData = Awaited<ReturnType<typeof storeSearchSuggest>>, TError = unknown>(
 params: StoreSearchSuggestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSearchSuggest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeSearchSuggest>>,
          TError,
          Awaited<ReturnType<typeof storeSearchSuggest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreSearchSuggest<TData = Awaited<ReturnType<typeof storeSearchSuggest>>, TError = unknown>(
 params: StoreSearchSuggestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSearchSuggest>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreSearchSuggest<TData = Awaited<ReturnType<typeof storeSearchSuggest>>, TError = unknown>(
 params: StoreSearchSuggestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSearchSuggest>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreSearchSuggestQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeSettingsRetrieveResponse200 = {
  data: PublicSettings
  status: 200
}

export type storeSettingsRetrieveResponseSuccess = (storeSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeSettingsRetrieveResponse = (storeSettingsRetrieveResponseSuccess)

export const getStoreSettingsRetrieveUrl = () => {




  return `/api/v1/store/settings`
}

/**
 * The marketplace's public contact details and shopping values (footer, contact page, policies). Never the
 * commercial or payout values.
 */
export const storeSettingsRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeSettingsRetrieveResponse> => {

  return apiFetch<storeSettingsRetrieveResponse>(getStoreSettingsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreSettingsRetrieveQueryKey = () => {
    return [
    `/api/v1/store/settings`
    ] as const;
    }


export const getStoreSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreSettingsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeSettingsRetrieve>>> = ({ signal }) => storeSettingsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeSettingsRetrieve>>>
export type StoreSettingsRetrieveQueryError = unknown


export function useStoreSettingsRetrieve<TData = Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreSettingsRetrieve<TData = Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreSettingsRetrieve<TData = Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreSettingsRetrieve<TData = Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreSettingsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeStoresRetrieveResponse200 = {
  data: StoreProfile
  status: 200
}

export type storeStoresRetrieveResponseSuccess = (storeStoresRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeStoresRetrieveResponse = (storeStoresRetrieveResponseSuccess)

export const getStoreStoresRetrieveUrl = (slug: string,) => {




  return `/api/v1/store/stores/${slug}`
}

/**
 * An approved store's public profile; 404 for unknown, unapproved, suspended or deleted stores.
 */
export const storeStoresRetrieve = async (slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeStoresRetrieveResponse> => {

  return apiFetch<storeStoresRetrieveResponse>(getStoreStoresRetrieveUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreStoresRetrieveQueryKey = (slug: string,) => {
    return [
    `/api/v1/store/stores/${slug}`
    ] as const;
    }


export const getStoreStoresRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeStoresRetrieve>>, TError = unknown>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeStoresRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreStoresRetrieveQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeStoresRetrieve>>> = ({ signal }) => storeStoresRetrieve(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeStoresRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreStoresRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeStoresRetrieve>>>
export type StoreStoresRetrieveQueryError = unknown


export function useStoreStoresRetrieve<TData = Awaited<ReturnType<typeof storeStoresRetrieve>>, TError = unknown>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeStoresRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeStoresRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeStoresRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreStoresRetrieve<TData = Awaited<ReturnType<typeof storeStoresRetrieve>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeStoresRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeStoresRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeStoresRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreStoresRetrieve<TData = Awaited<ReturnType<typeof storeStoresRetrieve>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeStoresRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreStoresRetrieve<TData = Awaited<ReturnType<typeof storeStoresRetrieve>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeStoresRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreStoresRetrieveQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeSupportCategoriesResponse200 = {
  data: TicketCategory[]
  status: 200
}

export type storeSupportCategoriesResponseSuccess = (storeSupportCategoriesResponse200) & {
  headers: Headers;
};
;

export type storeSupportCategoriesResponse = (storeSupportCategoriesResponseSuccess)

export const getStoreSupportCategoriesUrl = () => {




  return `/api/v1/store/support/categories`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const storeSupportCategories = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeSupportCategoriesResponse> => {

  return apiFetch<storeSupportCategoriesResponse>(getStoreSupportCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreSupportCategoriesQueryKey = () => {
    return [
    `/api/v1/store/support/categories`
    ] as const;
    }


export const getStoreSupportCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof storeSupportCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSupportCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreSupportCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeSupportCategories>>> = ({ signal }) => storeSupportCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeSupportCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreSupportCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof storeSupportCategories>>>
export type StoreSupportCategoriesQueryError = unknown


export function useStoreSupportCategories<TData = Awaited<ReturnType<typeof storeSupportCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSupportCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeSupportCategories>>,
          TError,
          Awaited<ReturnType<typeof storeSupportCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreSupportCategories<TData = Awaited<ReturnType<typeof storeSupportCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSupportCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeSupportCategories>>,
          TError,
          Awaited<ReturnType<typeof storeSupportCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreSupportCategories<TData = Awaited<ReturnType<typeof storeSupportCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSupportCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreSupportCategories<TData = Awaited<ReturnType<typeof storeSupportCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeSupportCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreSupportCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeTicketsListResponse200 = {
  data: PaginatedTicketListList
  status: 200
}

export type storeTicketsListResponseSuccess = (storeTicketsListResponse200) & {
  headers: Headers;
};
;

export type storeTicketsListResponse = (storeTicketsListResponseSuccess)

export const getStoreTicketsListUrl = (params?: StoreTicketsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/tickets?${stringifiedParams}` : `/api/v1/store/tickets`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const storeTicketsList = async (params?: StoreTicketsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeTicketsListResponse> => {

  return apiFetch<storeTicketsListResponse>(getStoreTicketsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreTicketsListQueryKey = (params?: StoreTicketsListParams,) => {
    return [
    `/api/v1/store/tickets`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreTicketsListQueryOptions = <TData = Awaited<ReturnType<typeof storeTicketsList>>, TError = unknown>(params?: StoreTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreTicketsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeTicketsList>>> = ({ signal }) => storeTicketsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeTicketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreTicketsListQueryResult = NonNullable<Awaited<ReturnType<typeof storeTicketsList>>>
export type StoreTicketsListQueryError = unknown


export function useStoreTicketsList<TData = Awaited<ReturnType<typeof storeTicketsList>>, TError = unknown>(
 params: undefined |  StoreTicketsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeTicketsList>>,
          TError,
          Awaited<ReturnType<typeof storeTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreTicketsList<TData = Awaited<ReturnType<typeof storeTicketsList>>, TError = unknown>(
 params?: StoreTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeTicketsList>>,
          TError,
          Awaited<ReturnType<typeof storeTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreTicketsList<TData = Awaited<ReturnType<typeof storeTicketsList>>, TError = unknown>(
 params?: StoreTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreTicketsList<TData = Awaited<ReturnType<typeof storeTicketsList>>, TError = unknown>(
 params?: StoreTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreTicketsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeTicketsCreateResponse201 = {
  data: TicketDetail
  status: 201
}

export type storeTicketsCreateResponseSuccess = (storeTicketsCreateResponse201) & {
  headers: Headers;
};
;

export type storeTicketsCreateResponse = (storeTicketsCreateResponseSuccess)

export const getStoreTicketsCreateUrl = () => {




  return `/api/v1/store/tickets`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const storeTicketsCreate = async (openRequest: OpenRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeTicketsCreateResponse> => {
    const formData = new FormData();
formData.append(`category`, openRequest.category);
formData.append(`subject`, openRequest.subject);
formData.append(`body`, openRequest.body);
if(openRequest.order !== undefined) {
 formData.append(`order`, openRequest.order);
 }
if(openRequest.attachments !== undefined) {
 openRequest.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return apiFetch<storeTicketsCreateResponse>(getStoreTicketsCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getStoreTicketsCreateMutationKey = () => ['storeTicketsCreate'] as const;

export const getStoreTicketsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeTicketsCreate>>, TError,StoreTicketsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeTicketsCreate>>, TError,StoreTicketsCreateMutationVariables, TContext> => {

const mutationKey = getStoreTicketsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeTicketsCreate>>, StoreTicketsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeTicketsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreTicketsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof storeTicketsCreate>>>
    export type StoreTicketsCreateMutationBody = OpenRequest
    export type StoreTicketsCreateMutationError = unknown
    export type StoreTicketsCreateMutationVariables = {data: OpenRequest}

    export const useStoreTicketsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeTicketsCreate>>, TError,StoreTicketsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeTicketsCreate>>,
        TError,
        StoreTicketsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStoreTicketsCreateMutationOptions(options), queryClient);
    }
    export type storeTicketsRetrieveResponse200 = {
  data: TicketDetail
  status: 200
}

export type storeTicketsRetrieveResponseSuccess = (storeTicketsRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeTicketsRetrieveResponse = (storeTicketsRetrieveResponseSuccess)

export const getStoreTicketsRetrieveUrl = (number: string,) => {




  return `/api/v1/store/tickets/${number}`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const storeTicketsRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeTicketsRetrieveResponse> => {

  return apiFetch<storeTicketsRetrieveResponse>(getStoreTicketsRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreTicketsRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/store/tickets/${number}`
    ] as const;
    }


export const getStoreTicketsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreTicketsRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeTicketsRetrieve>>> = ({ signal }) => storeTicketsRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreTicketsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeTicketsRetrieve>>>
export type StoreTicketsRetrieveQueryError = unknown


export function useStoreTicketsRetrieve<TData = Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreTicketsRetrieve<TData = Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreTicketsRetrieve<TData = Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreTicketsRetrieve<TData = Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreTicketsRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeTicketsAttachmentResponse200 = {
  data: Blob
  status: 200
}

export type storeTicketsAttachmentResponseSuccess = (storeTicketsAttachmentResponse200) & {
  headers: Headers;
};
;

export type storeTicketsAttachmentResponse = (storeTicketsAttachmentResponseSuccess)

export const getStoreTicketsAttachmentUrl = (number: string,
    media: string,) => {




  return `/api/v1/store/tickets/${number}/attachments/${media}`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const storeTicketsAttachment = async (number: string,
    media: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeTicketsAttachmentResponse> => {

  return apiFetch<storeTicketsAttachmentResponse>(getStoreTicketsAttachmentUrl(number,media),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreTicketsAttachmentQueryKey = (number: string,
    media: string,) => {
    return [
    `/api/v1/store/tickets/${number}/attachments/${media}`
    ] as const;
    }


export const getStoreTicketsAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof storeTicketsAttachment>>, TError = unknown>(number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreTicketsAttachmentQueryKey(number,media);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeTicketsAttachment>>> = ({ signal }) => storeTicketsAttachment(number,media, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined && media !== null && media !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeTicketsAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreTicketsAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof storeTicketsAttachment>>>
export type StoreTicketsAttachmentQueryError = unknown


export function useStoreTicketsAttachment<TData = Awaited<ReturnType<typeof storeTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeTicketsAttachment>>,
          TError,
          Awaited<ReturnType<typeof storeTicketsAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreTicketsAttachment<TData = Awaited<ReturnType<typeof storeTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeTicketsAttachment>>,
          TError,
          Awaited<ReturnType<typeof storeTicketsAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreTicketsAttachment<TData = Awaited<ReturnType<typeof storeTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreTicketsAttachment<TData = Awaited<ReturnType<typeof storeTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreTicketsAttachmentQueryOptions(number,media,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeTicketsReplyResponse200 = {
  data: TicketDetail
  status: 200
}

export type storeTicketsReplyResponseSuccess = (storeTicketsReplyResponse200) & {
  headers: Headers;
};
;

export type storeTicketsReplyResponse = (storeTicketsReplyResponseSuccess)

export const getStoreTicketsReplyUrl = (number: string,) => {




  return `/api/v1/store/tickets/${number}/reply`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const storeTicketsReply = async (number: string,
    replyRequest: ReplyRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeTicketsReplyResponse> => {
    const formData = new FormData();
formData.append(`body`, replyRequest.body);
if(replyRequest.is_internal_note !== undefined) {
 formData.append(`is_internal_note`, replyRequest.is_internal_note.toString())
 }
if(replyRequest.attachments !== undefined) {
 replyRequest.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return apiFetch<storeTicketsReplyResponse>(getStoreTicketsReplyUrl(number),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getStoreTicketsReplyMutationKey = () => ['storeTicketsReply'] as const;

export const getStoreTicketsReplyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeTicketsReply>>, TError,StoreTicketsReplyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeTicketsReply>>, TError,StoreTicketsReplyMutationVariables, TContext> => {

const mutationKey = getStoreTicketsReplyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeTicketsReply>>, StoreTicketsReplyMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  storeTicketsReply(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreTicketsReplyMutationResult = NonNullable<Awaited<ReturnType<typeof storeTicketsReply>>>
    export type StoreTicketsReplyMutationBody = ReplyRequest
    export type StoreTicketsReplyMutationError = unknown
    export type StoreTicketsReplyMutationVariables = {number: string;data: ReplyRequest}

    export const useStoreTicketsReply = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeTicketsReply>>, TError,StoreTicketsReplyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeTicketsReply>>,
        TError,
        StoreTicketsReplyMutationVariables,
        TContext
      > => {
      return useMutation(getStoreTicketsReplyMutationOptions(options), queryClient);
    }
    export type storeVehiclesRetrieveResponse200 = {
  data: ResolvedVehicle
  status: 200
}

export type storeVehiclesRetrieveResponseSuccess = (storeVehiclesRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeVehiclesRetrieveResponse = (storeVehiclesRetrieveResponseSuccess)

export const getStoreVehiclesRetrieveUrl = (uid: string,) => {




  return `/api/v1/store/vehicles/${uid}`
}

/**
 * One selectable vehicle by uid: the storefront's header tag for the `ml_vehicle` cookie.
 */
export const storeVehiclesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeVehiclesRetrieveResponse> => {

  return apiFetch<storeVehiclesRetrieveResponse>(getStoreVehiclesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreVehiclesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/store/vehicles/${uid}`
    ] as const;
    }


export const getStoreVehiclesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreVehiclesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeVehiclesRetrieve>>> = ({ signal }) => storeVehiclesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreVehiclesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeVehiclesRetrieve>>>
export type StoreVehiclesRetrieveQueryError = unknown


export function useStoreVehiclesRetrieve<TData = Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesRetrieve<TData = Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesRetrieve<TData = Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreVehiclesRetrieve<TData = Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreVehiclesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeVehiclesLandingResponse200 = {
  data: Landing
  status: 200
}

export type storeVehiclesLandingResponseSuccess = (storeVehiclesLandingResponse200) & {
  headers: Headers;
};
;

export type storeVehiclesLandingResponse = (storeVehiclesLandingResponseSuccess)

export const getStoreVehiclesLandingUrl = (params: StoreVehiclesLandingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/vehicles/landing?${stringifiedParams}` : `/api/v1/store/vehicles/landing`
}

/**
 * A vehicle landing page's header: model, years on offer and (with a year) its variants. 404 when not on offer.
 */
export const storeVehiclesLanding = async (params: StoreVehiclesLandingParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeVehiclesLandingResponse> => {

  return apiFetch<storeVehiclesLandingResponse>(getStoreVehiclesLandingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreVehiclesLandingQueryKey = (params?: StoreVehiclesLandingParams,) => {
    return [
    `/api/v1/store/vehicles/landing`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreVehiclesLandingQueryOptions = <TData = Awaited<ReturnType<typeof storeVehiclesLanding>>, TError = unknown>(params: StoreVehiclesLandingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesLanding>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreVehiclesLandingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeVehiclesLanding>>> = ({ signal }) => storeVehiclesLanding(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesLanding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreVehiclesLandingQueryResult = NonNullable<Awaited<ReturnType<typeof storeVehiclesLanding>>>
export type StoreVehiclesLandingQueryError = unknown


export function useStoreVehiclesLanding<TData = Awaited<ReturnType<typeof storeVehiclesLanding>>, TError = unknown>(
 params: StoreVehiclesLandingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesLanding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesLanding>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesLanding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesLanding<TData = Awaited<ReturnType<typeof storeVehiclesLanding>>, TError = unknown>(
 params: StoreVehiclesLandingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesLanding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesLanding>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesLanding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesLanding<TData = Awaited<ReturnType<typeof storeVehiclesLanding>>, TError = unknown>(
 params: StoreVehiclesLandingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesLanding>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreVehiclesLanding<TData = Awaited<ReturnType<typeof storeVehiclesLanding>>, TError = unknown>(
 params: StoreVehiclesLandingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesLanding>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreVehiclesLandingQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeVehiclesMakesListResponse200 = {
  data: PickerMake[]
  status: 200
}

export type storeVehiclesMakesListResponseSuccess = (storeVehiclesMakesListResponse200) & {
  headers: Headers;
};
;

export type storeVehiclesMakesListResponse = (storeVehiclesMakesListResponseSuccess)

export const getStoreVehiclesMakesListUrl = (params?: StoreVehiclesMakesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/vehicles/makes?${stringifiedParams}` : `/api/v1/store/vehicles/makes`
}

/**
 * Public, cached for 5 minutes in browsers / CDNs (and an hour on the server, refreshed on every change).
 */
export const storeVehiclesMakesList = async (params?: StoreVehiclesMakesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeVehiclesMakesListResponse> => {

  return apiFetch<storeVehiclesMakesListResponse>(getStoreVehiclesMakesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreVehiclesMakesListQueryKey = (params?: StoreVehiclesMakesListParams,) => {
    return [
    `/api/v1/store/vehicles/makes`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreVehiclesMakesListQueryOptions = <TData = Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError = unknown>(params?: StoreVehiclesMakesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreVehiclesMakesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeVehiclesMakesList>>> = ({ signal }) => storeVehiclesMakesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreVehiclesMakesListQueryResult = NonNullable<Awaited<ReturnType<typeof storeVehiclesMakesList>>>
export type StoreVehiclesMakesListQueryError = unknown


export function useStoreVehiclesMakesList<TData = Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError = unknown>(
 params: undefined |  StoreVehiclesMakesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesMakesList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesMakesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesMakesList<TData = Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError = unknown>(
 params?: StoreVehiclesMakesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesMakesList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesMakesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesMakesList<TData = Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError = unknown>(
 params?: StoreVehiclesMakesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreVehiclesMakesList<TData = Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError = unknown>(
 params?: StoreVehiclesMakesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesMakesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreVehiclesMakesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeVehiclesModelsListResponse200 = {
  data: PickerModel[]
  status: 200
}

export type storeVehiclesModelsListResponseSuccess = (storeVehiclesModelsListResponse200) & {
  headers: Headers;
};
;

export type storeVehiclesModelsListResponse = (storeVehiclesModelsListResponseSuccess)

export const getStoreVehiclesModelsListUrl = (params: StoreVehiclesModelsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/vehicles/models?${stringifiedParams}` : `/api/v1/store/vehicles/models`
}

/**
 * Public, cached for 5 minutes in browsers / CDNs (and an hour on the server, refreshed on every change).
 */
export const storeVehiclesModelsList = async (params: StoreVehiclesModelsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeVehiclesModelsListResponse> => {

  return apiFetch<storeVehiclesModelsListResponse>(getStoreVehiclesModelsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreVehiclesModelsListQueryKey = (params?: StoreVehiclesModelsListParams,) => {
    return [
    `/api/v1/store/vehicles/models`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreVehiclesModelsListQueryOptions = <TData = Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError = unknown>(params: StoreVehiclesModelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreVehiclesModelsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeVehiclesModelsList>>> = ({ signal }) => storeVehiclesModelsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreVehiclesModelsListQueryResult = NonNullable<Awaited<ReturnType<typeof storeVehiclesModelsList>>>
export type StoreVehiclesModelsListQueryError = unknown


export function useStoreVehiclesModelsList<TData = Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError = unknown>(
 params: StoreVehiclesModelsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesModelsList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesModelsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesModelsList<TData = Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError = unknown>(
 params: StoreVehiclesModelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesModelsList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesModelsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesModelsList<TData = Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError = unknown>(
 params: StoreVehiclesModelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreVehiclesModelsList<TData = Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError = unknown>(
 params: StoreVehiclesModelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesModelsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreVehiclesModelsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeVehiclesResolveRetrieveResponse200 = {
  data: ResolvedVehicle
  status: 200
}

export type storeVehiclesResolveRetrieveResponseSuccess = (storeVehiclesResolveRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeVehiclesResolveRetrieveResponse = (storeVehiclesResolveRetrieveResponseSuccess)

export const getStoreVehiclesResolveRetrieveUrl = (params: StoreVehiclesResolveRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/vehicles/resolve?${stringifiedParams}` : `/api/v1/store/vehicles/resolve`
}

/**
 * The selectable vehicle for variant + year (what the storefront remembers as the customer's vehicle).
 */
export const storeVehiclesResolveRetrieve = async (params: StoreVehiclesResolveRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeVehiclesResolveRetrieveResponse> => {

  return apiFetch<storeVehiclesResolveRetrieveResponse>(getStoreVehiclesResolveRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreVehiclesResolveRetrieveQueryKey = (params?: StoreVehiclesResolveRetrieveParams,) => {
    return [
    `/api/v1/store/vehicles/resolve`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreVehiclesResolveRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError = unknown>(params: StoreVehiclesResolveRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreVehiclesResolveRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>> = ({ signal }) => storeVehiclesResolveRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreVehiclesResolveRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>>
export type StoreVehiclesResolveRetrieveQueryError = unknown


export function useStoreVehiclesResolveRetrieve<TData = Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError = unknown>(
 params: StoreVehiclesResolveRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesResolveRetrieve<TData = Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError = unknown>(
 params: StoreVehiclesResolveRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesResolveRetrieve<TData = Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError = unknown>(
 params: StoreVehiclesResolveRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreVehiclesResolveRetrieve<TData = Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError = unknown>(
 params: StoreVehiclesResolveRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesResolveRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreVehiclesResolveRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeVehiclesTypesListResponse200 = {
  data: PickerItem[]
  status: 200
}

export type storeVehiclesTypesListResponseSuccess = (storeVehiclesTypesListResponse200) & {
  headers: Headers;
};
;

export type storeVehiclesTypesListResponse = (storeVehiclesTypesListResponseSuccess)

export const getStoreVehiclesTypesListUrl = () => {




  return `/api/v1/store/vehicles/types`
}

/**
 * Public, cached for 5 minutes in browsers / CDNs (and an hour on the server, refreshed on every change).
 */
export const storeVehiclesTypesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeVehiclesTypesListResponse> => {

  return apiFetch<storeVehiclesTypesListResponse>(getStoreVehiclesTypesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreVehiclesTypesListQueryKey = () => {
    return [
    `/api/v1/store/vehicles/types`
    ] as const;
    }


export const getStoreVehiclesTypesListQueryOptions = <TData = Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreVehiclesTypesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeVehiclesTypesList>>> = ({ signal }) => storeVehiclesTypesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreVehiclesTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof storeVehiclesTypesList>>>
export type StoreVehiclesTypesListQueryError = unknown


export function useStoreVehiclesTypesList<TData = Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesTypesList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesTypesList<TData = Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesTypesList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesTypesList<TData = Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreVehiclesTypesList<TData = Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreVehiclesTypesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeVehiclesVariantsListResponse200 = {
  data: PickerVariant[]
  status: 200
}

export type storeVehiclesVariantsListResponseSuccess = (storeVehiclesVariantsListResponse200) & {
  headers: Headers;
};
;

export type storeVehiclesVariantsListResponse = (storeVehiclesVariantsListResponseSuccess)

export const getStoreVehiclesVariantsListUrl = (params: StoreVehiclesVariantsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/vehicles/variants?${stringifiedParams}` : `/api/v1/store/vehicles/variants`
}

/**
 * Public, cached for 5 minutes in browsers / CDNs (and an hour on the server, refreshed on every change).
 */
export const storeVehiclesVariantsList = async (params: StoreVehiclesVariantsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeVehiclesVariantsListResponse> => {

  return apiFetch<storeVehiclesVariantsListResponse>(getStoreVehiclesVariantsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreVehiclesVariantsListQueryKey = (params?: StoreVehiclesVariantsListParams,) => {
    return [
    `/api/v1/store/vehicles/variants`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreVehiclesVariantsListQueryOptions = <TData = Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError = unknown>(params: StoreVehiclesVariantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreVehiclesVariantsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeVehiclesVariantsList>>> = ({ signal }) => storeVehiclesVariantsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreVehiclesVariantsListQueryResult = NonNullable<Awaited<ReturnType<typeof storeVehiclesVariantsList>>>
export type StoreVehiclesVariantsListQueryError = unknown


export function useStoreVehiclesVariantsList<TData = Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError = unknown>(
 params: StoreVehiclesVariantsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesVariantsList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesVariantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesVariantsList<TData = Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError = unknown>(
 params: StoreVehiclesVariantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesVariantsList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesVariantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesVariantsList<TData = Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError = unknown>(
 params: StoreVehiclesVariantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreVehiclesVariantsList<TData = Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError = unknown>(
 params: StoreVehiclesVariantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesVariantsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreVehiclesVariantsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeVehiclesYearsListResponse200 = {
  data: number[]
  status: 200
}

export type storeVehiclesYearsListResponseSuccess = (storeVehiclesYearsListResponse200) & {
  headers: Headers;
};
;

export type storeVehiclesYearsListResponse = (storeVehiclesYearsListResponseSuccess)

export const getStoreVehiclesYearsListUrl = (params?: StoreVehiclesYearsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/store/vehicles/years?${stringifiedParams}` : `/api/v1/store/vehicles/years`
}

/**
 * Public, cached for 5 minutes in browsers / CDNs (and an hour on the server, refreshed on every change).
 */
export const storeVehiclesYearsList = async (params?: StoreVehiclesYearsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<storeVehiclesYearsListResponse> => {

  return apiFetch<storeVehiclesYearsListResponse>(getStoreVehiclesYearsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreVehiclesYearsListQueryKey = (params?: StoreVehiclesYearsListParams,) => {
    return [
    `/api/v1/store/vehicles/years`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreVehiclesYearsListQueryOptions = <TData = Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError = unknown>(params?: StoreVehiclesYearsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreVehiclesYearsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeVehiclesYearsList>>> = ({ signal }) => storeVehiclesYearsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreVehiclesYearsListQueryResult = NonNullable<Awaited<ReturnType<typeof storeVehiclesYearsList>>>
export type StoreVehiclesYearsListQueryError = unknown


export function useStoreVehiclesYearsList<TData = Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError = unknown>(
 params: undefined |  StoreVehiclesYearsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesYearsList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesYearsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesYearsList<TData = Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError = unknown>(
 params?: StoreVehiclesYearsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeVehiclesYearsList>>,
          TError,
          Awaited<ReturnType<typeof storeVehiclesYearsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreVehiclesYearsList<TData = Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError = unknown>(
 params?: StoreVehiclesYearsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreVehiclesYearsList<TData = Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError = unknown>(
 params?: StoreVehiclesYearsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeVehiclesYearsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreVehiclesYearsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeWishlistRetrieveResponse200 = {
  data: Wishlist
  status: 200
}

export type storeWishlistRetrieveResponseSuccess = (storeWishlistRetrieveResponse200) & {
  headers: Headers;
};
;

export type storeWishlistRetrieveResponse = (storeWishlistRetrieveResponseSuccess)

export const getStoreWishlistRetrieveUrl = () => {




  return `/api/v1/store/wishlist`
}

export const storeWishlistRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<storeWishlistRetrieveResponse> => {

  return apiFetch<storeWishlistRetrieveResponse>(getStoreWishlistRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreWishlistRetrieveQueryKey = () => {
    return [
    `/api/v1/store/wishlist`
    ] as const;
    }


export const getStoreWishlistRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreWishlistRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeWishlistRetrieve>>> = ({ signal }) => storeWishlistRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreWishlistRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof storeWishlistRetrieve>>>
export type StoreWishlistRetrieveQueryError = unknown


export function useStoreWishlistRetrieve<TData = Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeWishlistRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeWishlistRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreWishlistRetrieve<TData = Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeWishlistRetrieve>>,
          TError,
          Awaited<ReturnType<typeof storeWishlistRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreWishlistRetrieve<TData = Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStoreWishlistRetrieve<TData = Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeWishlistRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreWishlistRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type storeWishlistAddResponse200 = {
  data: Wishlist
  status: 200
}

export type storeWishlistAddResponse201 = {
  data: Wishlist
  status: 201
}

export type storeWishlistAddResponseSuccess = (storeWishlistAddResponse200 | storeWishlistAddResponse201) & {
  headers: Headers;
};
;

export type storeWishlistAddResponse = (storeWishlistAddResponseSuccess)

export const getStoreWishlistAddUrl = () => {




  return `/api/v1/store/wishlist/items`
}

export const storeWishlistAdd = async (addRequest: AddRequest, options?: Parameters<typeof apiFetch>[1]): Promise<storeWishlistAddResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<storeWishlistAddResponse>(getStoreWishlistAddUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addRequest)
  }
);}





export const getStoreWishlistAddMutationKey = () => ['storeWishlistAdd'] as const;

export const getStoreWishlistAddMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeWishlistAdd>>, TError,StoreWishlistAddMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeWishlistAdd>>, TError,StoreWishlistAddMutationVariables, TContext> => {

const mutationKey = getStoreWishlistAddMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeWishlistAdd>>, StoreWishlistAddMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  storeWishlistAdd(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreWishlistAddMutationResult = NonNullable<Awaited<ReturnType<typeof storeWishlistAdd>>>
    export type StoreWishlistAddMutationBody = AddRequest
    export type StoreWishlistAddMutationError = unknown
    export type StoreWishlistAddMutationVariables = {data: AddRequest}

    export const useStoreWishlistAdd = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeWishlistAdd>>, TError,StoreWishlistAddMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeWishlistAdd>>,
        TError,
        StoreWishlistAddMutationVariables,
        TContext
      > => {
      return useMutation(getStoreWishlistAddMutationOptions(options), queryClient);
    }
    export type storeWishlistRemoveResponse204 = {
  data: void
  status: 204
}

export type storeWishlistRemoveResponseSuccess = (storeWishlistRemoveResponse204) & {
  headers: Headers;
};
;

export type storeWishlistRemoveResponse = (storeWishlistRemoveResponseSuccess)

export const getStoreWishlistRemoveUrl = (uid: string,) => {




  return `/api/v1/store/wishlist/items/${uid}`
}

export const storeWishlistRemove = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeWishlistRemoveResponse> => {

  return apiFetch<storeWishlistRemoveResponse>(getStoreWishlistRemoveUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStoreWishlistRemoveMutationKey = () => ['storeWishlistRemove'] as const;

export const getStoreWishlistRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeWishlistRemove>>, TError,StoreWishlistRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeWishlistRemove>>, TError,StoreWishlistRemoveMutationVariables, TContext> => {

const mutationKey = getStoreWishlistRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeWishlistRemove>>, StoreWishlistRemoveMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  storeWishlistRemove(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreWishlistRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof storeWishlistRemove>>>

    export type StoreWishlistRemoveMutationError = unknown
    export type StoreWishlistRemoveMutationVariables = {uid: string}

    export const useStoreWishlistRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeWishlistRemove>>, TError,StoreWishlistRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeWishlistRemove>>,
        TError,
        StoreWishlistRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getStoreWishlistRemoveMutationOptions(options), queryClient);
    }
    export type storeWishlistMoveToCartResponse200 = {
  data: Wishlist
  status: 200
}

export type storeWishlistMoveToCartResponseSuccess = (storeWishlistMoveToCartResponse200) & {
  headers: Headers;
};
;

export type storeWishlistMoveToCartResponse = (storeWishlistMoveToCartResponseSuccess)

export const getStoreWishlistMoveToCartUrl = (uid: string,) => {




  return `/api/v1/store/wishlist/items/${uid}/move-to-cart`
}

export const storeWishlistMoveToCart = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeWishlistMoveToCartResponse> => {

  return apiFetch<storeWishlistMoveToCartResponse>(getStoreWishlistMoveToCartUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStoreWishlistMoveToCartMutationKey = () => ['storeWishlistMoveToCart'] as const;

export const getStoreWishlistMoveToCartMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeWishlistMoveToCart>>, TError,StoreWishlistMoveToCartMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeWishlistMoveToCart>>, TError,StoreWishlistMoveToCartMutationVariables, TContext> => {

const mutationKey = getStoreWishlistMoveToCartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeWishlistMoveToCart>>, StoreWishlistMoveToCartMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  storeWishlistMoveToCart(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreWishlistMoveToCartMutationResult = NonNullable<Awaited<ReturnType<typeof storeWishlistMoveToCart>>>

    export type StoreWishlistMoveToCartMutationError = unknown
    export type StoreWishlistMoveToCartMutationVariables = {uid: string}

    export const useStoreWishlistMoveToCart = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeWishlistMoveToCart>>, TError,StoreWishlistMoveToCartMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeWishlistMoveToCart>>,
        TError,
        StoreWishlistMoveToCartMutationVariables,
        TContext
      > => {
      return useMutation(getStoreWishlistMoveToCartMutationOptions(options), queryClient);
    }
    export type storeWishlistRemoveVariantResponse204 = {
  data: void
  status: 204
}

export type storeWishlistRemoveVariantResponseSuccess = (storeWishlistRemoveVariantResponse204) & {
  headers: Headers;
};
;

export type storeWishlistRemoveVariantResponse = (storeWishlistRemoveVariantResponseSuccess)

export const getStoreWishlistRemoveVariantUrl = (variant: string,) => {




  return `/api/v1/store/wishlist/variants/${variant}`
}

export const storeWishlistRemoveVariant = async (variant: string, options?: Parameters<typeof apiFetch>[1]): Promise<storeWishlistRemoveVariantResponse> => {

  return apiFetch<storeWishlistRemoveVariantResponse>(getStoreWishlistRemoveVariantUrl(variant),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStoreWishlistRemoveVariantMutationKey = () => ['storeWishlistRemoveVariant'] as const;

export const getStoreWishlistRemoveVariantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeWishlistRemoveVariant>>, TError,StoreWishlistRemoveVariantMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof storeWishlistRemoveVariant>>, TError,StoreWishlistRemoveVariantMutationVariables, TContext> => {

const mutationKey = getStoreWishlistRemoveVariantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storeWishlistRemoveVariant>>, StoreWishlistRemoveVariantMutationVariables> = (props) => {
          const {variant} = props ?? {};

          return  storeWishlistRemoveVariant(variant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StoreWishlistRemoveVariantMutationResult = NonNullable<Awaited<ReturnType<typeof storeWishlistRemoveVariant>>>

    export type StoreWishlistRemoveVariantMutationError = unknown
    export type StoreWishlistRemoveVariantMutationVariables = {variant: string}

    export const useStoreWishlistRemoveVariant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storeWishlistRemoveVariant>>, TError,StoreWishlistRemoveVariantMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof storeWishlistRemoveVariant>>,
        TError,
        StoreWishlistRemoveVariantMutationVariables,
        TContext
      > => {
      return useMutation(getStoreWishlistRemoveVariantMutationOptions(options), queryClient);
    }
